const testData = {
  "startPage": "1085550",
  "printStylesUrl": "https://www.sira.nsw.gov.au/__data/assets/git_bridge/0004/1087132/dist/print.css",
  "emailAssetUrl": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/service-worker-tool-email",
  "restartButtonText": "Start tool again",
  "resultsPageSubheading": "Thank you for taking the time to connect with SIRA",
  "resultsPageRightHeading": "The information provided was...",
  "pages": {
    "1085550": {
      "id": "1085550",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0",
      "asset_name": "Worker status assessment",
      "complete_name": "Worker or Contractor Tool",
      "reference": "0.0",
      "option_displayed_on_parent": "",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Worker or Contractor Tool",
      "question": "The assessment process for guidance about the status of the person performing work for you.",
      "question_summary": "Begin the process to determine if a person performing work for you is either a 'worker', a 'deemed worker' or a 'contractor', for the purpose of workers compensation insurance premiums.",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Start",
      "parent": "1086057",
      "children": [
        "1085574"
      ]
    },
    "1085574": {
      "id": "1085574",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3",
      "asset_name": "1.0 (P1 &amp; P3)",
      "complete_name": "1.0 (P1 & P3) Purpose",
      "reference": "1.0 (P1 & P3)",
      "option_displayed_on_parent": "Start.",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Employer or principal contractor",
      "question": "Are you an employer or principal contractor?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1085550",
      "children": [
        "1085583",
        "1095109"
      ]
    },
    "1085583": {
      "id": "1085583",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4",
      "asset_name": "2.0 (P4)",
      "complete_name": "2.0 (P4) Digital platform or digital marketplace / gig economy",
      "reference": "2.0 (P4)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Digital platform or digital marketplace/gig economy",
      "question": "Is the person performing work, for whom you are seeking the most likely worker status, working/providing services via a digital platform or digital marketplace (that is, within the gig economy)?",
      "question_summary": "Is the person performing work, for whom you are seeking the most likely worker status, an individual providing â€˜on-demand servicesâ€™ or performing â€˜on-demand workâ€™ via a digital platform or digital marketplace within the gig economy?",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1085574",
      "children": [
        "1085589",
        "1085594"
      ]
    },
    "1085589": {
      "id": "1085589",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/p2.1-p7",
      "asset_name": "P2.1 (P7)",
      "complete_name": "P2.1 (P7) Exit: Not for digital platform, digital marketplace or gig economy",
      "reference": "P2.1 (P7)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Exit: Not for digital platform, digital marketplace or gig economy.",
      "question": "Cannot accurately determine the status of a person performing work/ providing services in the gig economy.",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1085583"
    },
    "1085594": {
      "id": "1085594",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6",
      "asset_name": "3.0 (P6)",
      "complete_name": "3.0 (P6) Disclaimer",
      "reference": "3.0 (P6)",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Disclaimer",
      "question": "I have read and understood the disclaimer.",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1085583",
      "children": [
        "1085604",
        "1085600"
      ]
    },
    "1085600": {
      "id": "1085600",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/3.1-p9",
      "asset_name": "3.1 (P9)",
      "complete_name": "3.1 (P9) Exit: Must agree to disclaimer",
      "reference": "3.1 (P9)",
      "option_displayed_on_parent": "Not agree",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Exit: Must agree to disclaimer",
      "question": "Exit explanation of purpose of tool.",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1085594"
    },
    "1085604": {
      "id": "1085604",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8",
      "asset_name": "4.0 (P8)",
      "complete_name": "4.0 (P8) Person or business classification assessment",
      "reference": "4.0 (P8)",
      "option_displayed_on_parent": "Agree",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Radio",
      "page_name": "Individual person or business classification assessment",
      "question": "Select the appropriate classification for the persons performing work: 1. A person (that is, not a partnership, not an incorporated entity and not an incorporated trustee), or 2. A partnership or incorporated trustee or incorporated entity.",
      "question_summary": "Select the appropriate classification for the persons performing work: 1. A person (that is, not a partner of a partnership, not an incorporated entity and not an incorporated trustee), or 2. An incorporated entity or incorporated trustee, or 3. An individual who is a partner, performing work for their partnership, or 4. An individual who is a partner, performing work for a principal contractor.",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1085594",
      "children": [
        "1085611",
        "1087621",
        "1128592",
        "1128600"
      ]
    },
    "1085611": {
      "id": "1085611",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10",
      "asset_name": "4.1 (P10)",
      "complete_name": "4.1 (P10) Select person classification assessment",
      "reference": "4.1 (P10)",
      "option_displayed_on_parent": "An individual person (that is, not a partner of a partnership, not an incorporated entity and not an incorporated trustee).",
      "option_displayed_on_parent_tooltip": "&lt;h2&gt;An individual person&lt;/h2&gt;&lt;p&gt;In this tool, an individual person is not a legal entity created by law. Examples of an individual person include:&lt;/p&gt;&lt;ul&gt;&lt;li&gt;a sole trader&lt;/li&gt;&lt;li&gt;a working director&lt;/li&gt;&lt;li&gt;a working beneficiary of a trust&lt;/li&gt;&lt;li&gt;a named individual trustee of a trust (as opposed to a company or incorporated entity being the trustee of the trust)&lt;/li&gt;&lt;li&gt;an individual person working for another person, or working for an entity (that is, a partnership, or an incorporated trustee or an incorporated entity).&lt;/li&gt;&lt;/ul&gt;",
      "options_type_display": "Radio",
      "page_name": "Individual person classification assessment",
      "question": "Is the 'person' performing work, one of the following:&#160;A) A working director, an incorporated entity or working beneficiary of a trust. (That is, a working beneficiary of an incorporated trust or a working beneficiary of an unincorporated trust.)&#160;B) A person who has a contract (not being an employment contract nor being a training contract), with a labour hirer.&#160;C) A person performing work engaged in any of the deeming provisions.&#160;D) No, the person performing work does not fall into any of the above categories.",
      "question_summary": "Is the individual person performing work, one of the following: 1) A working director, an incorporated entity or working beneficiary of a trust. (That is, a working beneficiary of an incorporated trust or a working beneficiary of an unincorporated trust.) 2) A person who has a contract (not being an employment contract nor being a training contract), with a labour hirer. 3) A person performing work engaged in any of the deeming provisions. 4) No, the person performing work does not fall into any of the above categories.",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1085604",
      "children": [
        "1085615",
        "1087891",
        "1089935",
        "1090103"
      ]
    },
    "1085615": {
      "id": "1085615",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.1-p12",
      "asset_name": "4.1.1 (P12)",
      "complete_name": "4.1.1 (P12) A) Working director or working beneficiary assessment",
      "reference": "4.1.1 (P12)",
      "option_displayed_on_parent": "A working director of an incorporated entity or a working beneficiary of a trust. (That is, a working beneficiary of an incorporated trust or a working beneficiary of an unincorporated trust.)",
      "option_displayed_on_parent_tooltip": "&lt;p&gt;&lt;strong&gt;Working director&lt;/strong&gt;&lt;/p&gt;&lt;p&gt;A working director of an incorporated entity who receives any form of consideration for performing work in the day-to-day operations of the business, such as administration or management will be considered to be a worker of that incorporated entity.&lt;/p&gt;&lt;p&gt;&lt;strong&gt;Working beneficiary of a trust&lt;/strong&gt;&lt;/p&gt;&lt;p&gt;A beneficiary of a trust is considered to be a &amp;lsquo;working beneficiary&amp;rsquo;(and thus considered a worker), if the person performing work for that trust or for the trustee of that trust (in his/her capacity as trustee) and if the beneficiary receives consideration in the form of money or money&amp;rsquo;s worth for the work performed, even if the &amp;lsquo;consideration&amp;rsquo; is not explicitly identified as wages, but is rather expressed to be a &amp;lsquo;trust distribution&amp;rsquo;.&lt;/p&gt;",
      "options_type_display": "Button",
      "page_name": "A) Working director or working beneficiary assessment",
      "question": "Is the person a working director of an incorporated entity or a working beneficiary of a trust?",
      "question_summary": "Is the individual person a working director of an incorporated entity or a working beneficiary of a trust?",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1085611",
      "children": [
        "1085887",
        "1085891"
      ]
    },
    "1085887": {
      "id": "1085887",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.2-p18/5.0-p46/8.1-p13",
      "asset_name": "8.1 (P13)",
      "complete_name": "8.1 (P13) Worker results page",
      "reference": "8.1 (P13)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Worker results page",
      "question": "Based on your inputs, the person appears to be a &#34;worker&#34; as per Workers Compensation legislation.",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1087793"
    },
    "1085891": {
      "id": "1085891",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.2-p18/4.2.3/5.0-p46",
      "asset_name": "5.0 (P46)",
      "complete_name": "5.0 (P46) Worker status of a natural person assessment -step 1",
      "reference": "5.0 (P46)",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Worker status of a person - step 1",
      "question": "Is the person covered by an apprenticeship or trainee contract?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1087649",
      "children": [
        "1085887",
        "1085963"
      ]
    },
    "1085963": {
      "id": "1085963",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.2-p18/5.0-p46/5.1",
      "asset_name": "5.1",
      "complete_name": "5.1 Police exclusions assessment",
      "reference": "5.1",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Police exclusions assessment",
      "question": "Is the person a member of the NSW Police Force who contributes to the Police Superannuation Fund?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1087793",
      "children": [
        "1085968",
        "1085972"
      ]
    },
    "1085968": {
      "id": "1085968",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.4/7.0-p53/8.3-p135",
      "asset_name": "8.3 (P135)",
      "complete_name": "8.3 (P135) Contractor results page",
      "reference": "8.3 (P135)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Contractor results page",
      "question": "Based on your inputs, the person appears to be a contractor.",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1088340"
    },
    "1085972": {
      "id": "1085972",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.2-p18/5.0-p46/5.1/5.2",
      "asset_name": "5.2",
      "complete_name": "5.2 One off casual persons assessment",
      "reference": "5.2",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "One off casual persons assessment",
      "question": "Is the person employed as a casual (that is for 1 period only of not more than 5 working days) and employed otherwise than for the employer&#39;s trade or business?",
      "question_summary": "Is the person employed as a casual - that is for 1 period only of not more than 5 working days and employed otherwise than for the employers trade or business?",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1085963",
      "children": [
        "1085968",
        "1085987"
      ]
    },
    "1085987": {
      "id": "1085987",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.2-p18/5.0-p46/5.1/5.2/5.3",
      "asset_name": "5.3",
      "complete_name": "5.3 Out of hours work for religious or other voluntary association assessment",
      "reference": "5.3",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Out of hours work for religious or other voluntary association assessment",
      "question": "Is the person an officer of a religious or other voluntary association who is employed upon duties for the association outside the officer&#39;s ordinary work hours, so far as the employment on those duties is concerned, if the officer&#39;s remuneration from the association does not exceed $700 per year)",
      "question_summary": "Is the person an officer of a religious or other voluntary association who is employed upon duties for the association outside the officer ordinary work hours, so far as the employment on those duties is concerned, if the officers remuneration from the association does not exceed $700 per year)",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1085972",
      "children": [
        "1085968",
        "1085997"
      ]
    },
    "1085997": {
      "id": "1085997",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.2-p18/5.0-p46/5.1/5.2/5.3/5.4",
      "asset_name": "5.4",
      "complete_name": "5.4 Participant in a sporting organisation assessment",
      "reference": "5.4",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Participant in a sporting organisation assessment",
      "question": "Is the person a registered participant of a sporting organisation (within the meaning of the Sporting Injuries Insurance Act 1978) while who received remuneration for participating, training or preparing to participate, or journey in connection with participation where remuneration is given only for that purpose?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1085987",
      "children": [
        "1085968",
        "1086005"
      ]
    },
    "1086005": {
      "id": "1086005",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.2-p18/5.0-p46/5.1/5.2/5.3/5.4/6.0-p137",
      "asset_name": "6.0 (P137)",
      "complete_name": "6.0 (P137) Natural Persons Assessment (Sole Trader/Individual) - Step 2",
      "reference": "6.0 (P137)",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Person assessment (Sole Trader/Individual) - Step 2",
      "question": "Does the person subcontract or employ 3rd persons?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1085997",
      "children": [
        "1088340",
        "1086009"
      ]
    },
    "1086009": {
      "id": "1086009",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.2-p18/5.0-p46/5.1/5.2/5.3/5.4/6.0-p137/6.1-p138",
      "asset_name": "6.1 (P138)",
      "complete_name": "Advertise business on a commercial basis",
      "reference": "6.1 (P138)",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Advertise business on a commercial basis",
      "question": "Does the person performing work independently advertise their business services on a commercial basis?",
      "question_summary": "Does the person performing work, independently advertise their business services on a commercial basis?",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1086005",
      "children": [
        "1088340",
        "1086013"
      ]
    },
    "1086013": {
      "id": "1086013",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.2-p18/5.0-p46/5.1/5.2/5.3/5.4/6.0-p137/6.1-p138/6.2-p139",
      "asset_name": "6.2 (P139)",
      "complete_name": "6.2 (P139) Digital platform or digital marketplace/gig economy",
      "reference": "6.2 (P139)",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Digital platform or digital marketplace/gig economy",
      "question": "Is the person performing work sourcing the work from the customer through a platform?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1086009",
      "children": [
        "1085589",
        "1086021"
      ]
    },
    "1086021": {
      "id": "1086021",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.2-p18/5.0-p46/5.1/5.2/5.3/5.4/6.0-p137/6.1-p138/6.2-p139/6.3-p140",
      "asset_name": "6.3 (P140)",
      "complete_name": "6.3 (P140) Performing work based on a quote",
      "reference": "6.3 (P140)",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Performing work based on a quote",
      "question": "Does the person performing work provide an upfront job by job quote?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1086013",
      "children": [
        "1088340",
        "1086026"
      ]
    },
    "1086026": {
      "id": "1086026",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.2-p18/5.0-p46/5.1/5.2/5.3/5.4/6.0-p137/6.1-p138/6.2-p139/6.3-p140/6.4-141",
      "asset_name": "6.4 (141)",
      "complete_name": "6.4 (141) Provide own plant, material or tools and equipment",
      "reference": "6.4 (141)",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Provide own plant, material or tools and equipment",
      "question": "Does the person performing work provide plant and/or material or supply their own tools and equipment?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1086021",
      "children": [
        "1088340",
        "1086031"
      ]
    },
    "1086031": {
      "id": "1086031",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.2-p18/5.0-p46/5.1/5.2/5.3/5.4/6.0-p137/6.1-p138/6.2-p139/6.3-p140/6.4-141/6.5-p142",
      "asset_name": "6.5 (P142)",
      "complete_name": "6.5 (P142) Paid at a set rate",
      "reference": "6.5 (P142)",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Paid at a set rate",
      "question": "Is the person paid at a set rate? E.g. hourly, weekly (a time rate of pay)",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1086026",
      "children": [
        "1086035",
        "1088904"
      ]
    },
    "1086035": {
      "id": "1086035",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.2-p18/5.0-p46/5.1/5.2/5.3/5.4/6.0-p137/6.1-p138/6.2-p139/6.3-p140/6.4-141/6.5-p142/6.6-p143",
      "asset_name": "6.6 (P143)",
      "complete_name": "6.6 (P143) Paid annual leave, sick leave, super and PAYG",
      "reference": "6.6 (P143)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Paid annual leave, sick leave, super and PAYG",
      "question": "Is the person performing work paid annual leave, sick leave, super and PAYG by the employer?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1086031",
      "children": [
        "1086039",
        "1088904"
      ]
    },
    "1086039": {
      "id": "1086039",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.2-p18/5.0-p46/5.1/5.2/5.3/5.4/6.0-p137/6.1-p138/6.2-p139/6.3-p140/6.4-141/6.5-p142/6.6-p143/6.7-p144",
      "asset_name": "6.7 (P144)",
      "complete_name": "6.7 (P144) Direction and control by the employer",
      "reference": "6.7 (P144)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Direction and control by the employer",
      "question": "Is the person performing work subject to direction and control by the employer?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1086035",
      "children": [
        "1086043",
        "1088904"
      ]
    },
    "1086043": {
      "id": "1086043",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.2-p18/5.0-p46/5.1/5.2/5.3/5.4/6.0-p137/6.1-p138/6.2-p139/6.3-p140/6.4-141/6.5-p142/6.6-p143/6.7-p144/6.8-p145",
      "asset_name": "6.8 (P145)",
      "complete_name": "6.8 (P145) Rectify work at own cost",
      "reference": "6.8 (P145)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Rectify work at own cost",
      "question": "Does the person performing work rectify any mistakes at their own cost?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1086039",
      "children": [
        "1088340",
        "1088775"
      ]
    },
    "1087621": {
      "id": "1087621",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.2-p18",
      "asset_name": "4.2 (P18)",
      "complete_name": "4.2 Incorporated entity or incorporated trustee",
      "reference": "4.2",
      "option_displayed_on_parent": "Incorporated entity or incorporated trustee.",
      "option_displayed_on_parent_tooltip": "&lt;h2&gt;Incorporated entities&lt;/h2&gt;&lt;p&gt;Incorporated entities will not be workers or deemed workers, within NSW workers compensation legislation (for the purpose of premiums). However, please note that a working director of an incorporated entity is classified as a worker of that incorporated entity.&lt;/p&gt;&lt;p&gt;If you need to find the worker status of a director of an incorporated entity (that is, as to whether the director is classified as a working director) using this tool, please start the tool again and answer the questions accordingly.&lt;/p&gt;&lt;p&gt;Employers are required by law to obtain and maintain workers compensation insurance in respect of all workers (and deemed workers) including working directors.&lt;/p&gt;&lt;h2&gt;Incorporated trustees&lt;/h2&gt;&lt;p&gt;Incorporated trustees will not be workers or deemed workers for the purpose of insurance premiums.&lt;/p&gt;&lt;p&gt;However, a working beneficiary of a trust is classified as a worker of that trust. If you need to find the worker status of a beneficiary of a trust (that is, whether the beneficiary is classified as a working beneficiary) using this tool, please start the tool again and answer the questions accordingly.&lt;/p&gt;&lt;p&gt;Employers are required by law to obtain and maintain workers compensation insurance in respect of all workers (and deemed workers), including working beneficiaries.&lt;/p&gt;",
      "options_type_display": "Radio",
      "page_name": "Incorporated entity or incorporated trustee",
      "question": "Select the appropriate classification for the persons performing work:",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1085604",
      "children": [
        "1087641",
        "1087649",
        "1087793"
      ]
    },
    "1087641": {
      "id": "1087641",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.2-p18/8.5-p25",
      "asset_name": "8.5 (P25)",
      "complete_name": "8.5 (P25) Contractor results page",
      "reference": "8.5 (P25)",
      "option_displayed_on_parent": "The person performing work is an incorporated entity.",
      "option_displayed_on_parent_tooltip": "&lt;h2&gt;Incorporated entities&lt;/h2&gt;&lt;p&gt;Incorporated entities will not be workers or deemed workers, within NSW workers compensation legislation (for the purpose of premiums). However, please note that a working director of an incorporated entity is classified as a worker of that incorporated entity.&lt;/p&gt;&lt;p&gt;If you need to find the worker status of&amp;nbsp;a working director of an incorporated entity, you can use this tool for that purpose.&lt;/p&gt;&lt;p&gt;If you want to use this tool for that purpose, please start the tool again and answer the questions accordingly.&lt;/p&gt;&lt;p&gt;Employers are required by law to obtain and maintain workers compensation insurance in respect of all workers (and deemed workers) including working directors.&lt;/p&gt;",
      "options_type_display": "Button",
      "page_name": "Contractor results page",
      "question": "",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1087621"
    },
    "1087649": {
      "id": "1087649",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.2-p18/4.2.3",
      "asset_name": "4.2.3",
      "complete_name": "4.2.3 Incorporated trustee assessment",
      "reference": "4.2.3",
      "option_displayed_on_parent": "The person performing work is a trustee of a trust. (That is, an incorporated trust or natural trust.)",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Radio",
      "page_name": "Incorporated trustee assessment",
      "question": "1.Is the trustee of the trust incorporated? or 2.Is the trustee a natual person?",
      "question_summary": "1. The trustee of the trust incorporated, or 2) The trustee is a person?",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1087621",
      "children": [
        "1095859",
        "1085891"
      ]
    },
    "1087793": {
      "id": "1087793",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.2-p18/5.0-p46",
      "asset_name": "5.0 (P46)",
      "complete_name": "5.0 (P46) Worker status of a natural person assessment - step 1",
      "reference": "5.0 (P46)",
      "option_displayed_on_parent": "None of the above",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Worker status of a natural person assessment - step 1",
      "question": "",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1087621",
      "children": [
        "1085887",
        "1085963"
      ]
    },
    "1087891": {
      "id": "1087891",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.2-p12",
      "asset_name": "4.1.2 (P12)",
      "complete_name": "4.1.2 (P12)B) Contract of service or training contract with a labour hirer assessment",
      "reference": "4.1.2 (P12)",
      "option_displayed_on_parent": "An individual person who has a contract (not being an employment contract nor being a training contract), with a labour hirer.",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "B) Contract of service or training contract with a labour hirer assessment",
      "question": "Has the person performing work entered into a contract of service or training contract with a labour hirer (that is, the person performing work is a worker of the labour hirer)?",
      "question_summary": "Has the individual person performing work entered into a contract of service or training contract with a labour hirer (that is, the person performing work is a worker of the labour hirer)?",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1085611",
      "children": [
        "1087895",
        "1085891"
      ]
    },
    "1087895": {
      "id": "1087895",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.2-p12/4.1.2.1-p14-a",
      "asset_name": "4.1.2.1 (P14 A)",
      "complete_name": "4.1.2.1 (P14 A) Labour buyer worker assessment",
      "reference": "4.1.2.1 (P14 A)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Labour buyer worker assessment",
      "question": "Is the service of the worker temporarily let or lent on hire to another person (the labour buyer)?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1087891",
      "children": [
        "1088976",
        "1088980"
      ]
    },
    "1088340": {
      "id": "1088340",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.4/7.0-p53",
      "asset_name": "7.0 (P53)",
      "complete_name": "7.0 (P53) Other contractors assessment",
      "reference": "7.0 (P53)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Other contractors assessment",
      "question": "Does the person performing work under the contract, subcontract or employ any other worker?Â ",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1128600",
      "children": [
        "1085968",
        "1088348"
      ]
    },
    "1088348": {
      "id": "1088348",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.4/7.0-p53/7.1-p55",
      "asset_name": "7.1 (p55)",
      "complete_name": "7.1 (p55) Other contractors assessment - own business",
      "reference": "7.1 (p55)",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Other contractors assessment - own business",
      "question": "Does the person performing work regularly carry on their own business or trade?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1088340",
      "children": [
        "1088352",
        "1099205"
      ]
    },
    "1088352": {
      "id": "1088352",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.4/7.0-p53/7.1-p55/7.1.1-p56",
      "asset_name": "7.1.1 (p56)",
      "complete_name": "7.1.1 (p56)  Other contractors assessment - different business type",
      "reference": "7.1.1 (p56)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Other contractors assessment - different business type",
      "question": "Is the type of work being performed for the benefit of the head contractor's / employer's business, different to the type of work the person usually does in their own business?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1088348",
      "children": [
        "1088359",
        "1095220"
      ]
    },
    "1088359": {
      "id": "1088359",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.4/7.0-p53/7.1-p55/7.1.1-p56/7.1.1.1-p58old",
      "asset_name": "7.1.1.1 (p58)",
      "complete_name": "7.1.1.1 (p58) Other contractors assessment - value of the work",
      "reference": "7.1.1.1 (p58)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Other contractors assessment - value of the work",
      "question": "Value of the work: Is the contract valued at over $10?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1088352",
      "children": [
        "1088364",
        "1088376"
      ]
    },
    "1088364": {
      "id": "1088364",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.4/7.0-p53/7.1-p55/7.1.1.1-p58/7.1.1.1.1-p60",
      "asset_name": "7.1.1.1.1 (P60)",
      "complete_name": "7.1.1.1.1 (P60) Other contractors assessment - registered participant sporting organisations",
      "reference": "7.1.1.1.1 (P60)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Other contractors assessment - registered participant sporting organisations",
      "question": "Is the person a registered participant of a sporting organisation covered by section 4(1)(d) of the 1998 Act?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1099205",
      "children": [
        "1088368",
        "1088372"
      ]
    },
    "1088368": {
      "id": "1088368",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.4/7.0-p53/7.1-p55/7.1.1.1-p58/7.1.1.1.1-p60/8.8-p61",
      "asset_name": "8.8 (P61)",
      "complete_name": "8.8 (P61)  Other Contractor results page",
      "reference": "8.8 (P61)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Other Contractor results page",
      "question": "Our Guidance: Contractor (Not a worker or a deemed worker)",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1088364"
    },
    "1088372": {
      "id": "1088372",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.1-p48/9.1.2-p49/8.9-p62",
      "asset_name": "8.9 (P62)",
      "complete_name": "8.9 (P62) Deemed worker results page",
      "reference": "8.9 (P62)",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Deemed worker results page",
      "question": "Our Guidance: Deemed Worker",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1089945"
    },
    "1088376": {
      "id": "1088376",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.4/7.0-p53/7.1-p55/7.1.1.1-p58/8.10-p59",
      "asset_name": "8.10 (P59)",
      "complete_name": "8.10 (P59) Other contractor results page",
      "reference": "8.10 (P59)",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Other contractor results page",
      "question": "Our Guidance: Contractor (Not a worker or a deemed worker)",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1099205"
    },
    "1088775": {
      "id": "1088775",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.2-p18/5.0-p46/5.1/5.2/5.3/5.4/6.0-p137/6.1-p138/6.2-p139/6.3-p140/6.4-141/6.5-p142/6.6-p143/6.7-p144/6.8-p145/8.55-p146",
      "asset_name": "8.55 (P146)",
      "complete_name": "8.55 (P146) Worker results page",
      "reference": "8.55 (P146)",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Worker results page",
      "question": "",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1086043"
    },
    "1088904": {
      "id": "1088904",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.8-p94/7.0-p53",
      "asset_name": "7.0 (P53)",
      "complete_name": "7.0 (P53) Other contractors assessment",
      "reference": "7.0 (P53)",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Other contractors assessment",
      "question": "Does the person performing work under the contract, subcontract or employ any other worker?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095509",
      "children": [
        "1085968",
        "1088348"
      ]
    },
    "1088976": {
      "id": "1088976",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.2-p12/4.1.2.1-p14-a/8.80-p15",
      "asset_name": "8.80 (P15)",
      "complete_name": "8.80 (P15) Deemed worker of a labour hirer results page",
      "reference": "8.80 (P15)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Deemed worker of a labour hirer results page",
      "question": "Our Guidance: Deemed Worker of the labour hirer",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1087895"
    },
    "1088980": {
      "id": "1088980",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.2-p12/4.1.2.1-p14-a/8.81-p14b",
      "asset_name": "8.81 (P14b)",
      "complete_name": "8.81 (P14b) Worker of labour hirer results page",
      "reference": "8.81 (P14b)",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Worker of labour hirer results page",
      "question": "Our Guidance: Worker of the labour hirer",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1087895"
    },
    "1089935": {
      "id": "1089935",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16",
      "asset_name": "4.1.3 (P16)",
      "complete_name": "4.1.3 (P16) C) Deemed worker provisions assessment",
      "reference": "4.1.3 (P16)",
      "option_displayed_on_parent": "An individual person performing work engaged in any of the deeming provisions.",
      "option_displayed_on_parent_tooltip": "&lt;h2&gt;List of deeming provisions&lt;/h2&gt;&lt;p&gt;The deeming provisions are listed in &lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1&quot; target=&quot;_blank&quot;&gt;Schedule 1 of the &lt;em&gt;Workplace Injury Management and Workers Compensation Act 1998&lt;/em&gt;&lt;/a&gt;&lt;em&gt; &lt;/em&gt;(the 1998 Act).&lt;/p&gt;&lt;table id=&quot;table85166&quot;&gt;&lt;tbody&gt;&lt;tr&gt;&lt;td&gt;Outworkers (&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.1A&quot; target=&quot;_blank&quot;&gt;Clause 1A)&lt;/a&gt;&lt;/td&gt;&lt;td&gt;Contractors under a labour hire agreement (&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.2A&quot; style=&quot;border: 0px&quot; target=&quot;_blank&quot;&gt;Clause 2A&lt;/a&gt;)&lt;/td&gt;&lt;/tr&gt;&lt;tr&gt;&lt;td&gt;Rural work (&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.3&quot; target=&quot;_blank&quot;&gt;Clause 3&lt;/a&gt;)&lt;/td&gt;&lt;td&gt;Timbergetters (&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.4&quot; target=&quot;_blank&quot;&gt;Clause 4&lt;/a&gt;)&lt;/td&gt;&lt;/tr&gt;&lt;tr&gt;&lt;td&gt;Salespersons, canvassers and others (&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.5&quot; style=&quot;border: 0px&quot; target=&quot;_blank&quot;&gt;Clause 5&lt;/a&gt;)&lt;/td&gt;&lt;td&gt;Tributers (&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.6&quot; target=&quot;_blank&quot;&gt;Clause 6&lt;/a&gt;)&lt;/td&gt;&lt;/tr&gt;&lt;tr&gt;&lt;td&gt;Mine employees (&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.7&quot; target=&quot;_blank&quot;&gt;Clause 7&lt;/a&gt;)&lt;/td&gt;&lt;td&gt;Mine rescue personnel (&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.8&quot; target=&quot;_blank&quot;&gt;Clause 8&lt;/a&gt;)&lt;/td&gt;&lt;/tr&gt;&lt;tr&gt;&lt;td&gt;Jockeys and harness racing drivers (&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.9&quot; target=&quot;_blank&quot;&gt;Clause 9&lt;/a&gt;)&lt;/td&gt;&lt;td&gt;Drivers of hire vehicles or hire vessels &amp;ndash; contract of bailment (&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.10&quot; target=&quot;_blank&quot;&gt;Clause 10&lt;/a&gt;)&lt;/td&gt;&lt;/tr&gt;&lt;tr&gt;&lt;td&gt;Caddies and others employed through a club (&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.11&quot; target=&quot;_blank&quot;&gt;Clause 11&lt;/a&gt;)&lt;/td&gt;&lt;td&gt;Shearers, cooks and others (&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.12&quot; target=&quot;_blank&quot;&gt;Clause 12&lt;/a&gt;)&lt;/td&gt;&lt;/tr&gt;&lt;tr&gt;&lt;td&gt;Fire fighters in fire districts (&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.13&quot; target=&quot;_blank&quot;&gt;Clause 13&lt;/a&gt;)&lt;/td&gt;&lt;td&gt;Workers at place of pickup (&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.14&quot; target=&quot;_blank&quot;&gt;Clause 14&lt;/a&gt;)&lt;/td&gt;&lt;/tr&gt;&lt;tr&gt;&lt;td&gt;Boxers, wrestlers, referees and entertainers (&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.15&quot; target=&quot;_blank&quot;&gt;Clause 15&lt;/a&gt;)&lt;/td&gt;&lt;td&gt;Voluntary ambulance workers (&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.16&quot; target=&quot;_blank&quot;&gt;Clause 16&lt;/a&gt;)&lt;/td&gt;&lt;/tr&gt;&lt;tr&gt;&lt;td&gt;Ministers of religion (&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.17&quot; target=&quot;_blank&quot;&gt;Clause 17&lt;/a&gt;)&lt;/td&gt;&lt;td&gt;Ministers of religion covered by policies (&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.18&quot; target=&quot;_blank&quot;&gt;Clause 18&lt;/a&gt;)&lt;/td&gt;&lt;/tr&gt;&lt;tr&gt;&lt;td&gt;Participants in training programs (&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.19&quot;&gt;Clause 19&lt;/a&gt;)&lt;/td&gt;&lt;td&gt;&lt;/td&gt;&lt;/tr&gt;&lt;/tbody&gt;&lt;/table&gt;",
      "options_type_display": "Radio",
      "page_name": "C) Deemed worker provisions assessment",
      "question": "Is the person performing work doing any of the following:",
      "question_summary": "Select the deeming provision that applies to the individual person performing work.",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1085611",
      "children": [
        "1089941",
        "1095268",
        "1095354",
        "1095384",
        "1095424",
        "1095450",
        "1095460",
        "1095509",
        "1095526",
        "1095615",
        "1095629",
        "1095648",
        "1095662",
        "1095672",
        "1095683",
        "1095728",
        "1095738",
        "1095751",
        "1095772",
        "1101437"
      ]
    },
    "1089941": {
      "id": "1089941",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.1-p48",
      "asset_name": "9.1 (P48)",
      "complete_name": "9.1 (P48) Outworker assessment - step 1 (Schedule 1 â€“ Clause 1A 1998 Act)",
      "reference": "9.1 (P48)",
      "option_displayed_on_parent": "Outworker assessment",
      "option_displayed_on_parent_tooltip": "&lt;p&gt;The legislation relevant to outworkers is &lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.1A&quot; target=&quot;_blank&quot;&gt;Clause 1A&lt;/a&gt; of the&amp;nbsp;&lt;em&gt;Workplace Injury Management and Workers Compensation Act 1998.&amp;nbsp;&lt;/em&gt; An excerpt from the Act is below.&lt;/p&gt;&lt;h3&gt;1A Outworkers&lt;/h3&gt;&lt;p&gt;(1)&amp;nbsp;&amp;nbsp;If&amp;mdash;&lt;/p&gt;&lt;p&gt;(a)&amp;nbsp;&amp;nbsp;a person (the principal) contracts with another person to perform any work as an outworker, and&lt;/p&gt;&lt;p&gt;(b)&amp;nbsp;&amp;nbsp;the outworker neither employs any worker, nor subcontracts with any person, to perform any of the work for the profit of the outworker,&lt;/p&gt;&lt;p&gt;the outworker is, for the purposes of this Act, taken to be a worker employed by the principal.&lt;/p&gt;&lt;p&gt;(2)&amp;nbsp;&amp;nbsp;In this clause&amp;mdash;&lt;/p&gt;&lt;p&gt;outworker means a person to whom articles or materials are given out to be made up, cleaned, washed, altered, ornamented, finished or repaired, or adapted for sale&amp;mdash;&lt;/p&gt;&lt;p&gt;(a)&amp;nbsp;&amp;nbsp;in the person&amp;rsquo;s own home, or&lt;/p&gt;&lt;p&gt;(b)&amp;nbsp;&amp;nbsp;on other premises not under the control or management of the person who gave out the articles or materials.&lt;/p&gt;&lt;div id=&quot;wrap&quot;&gt;&lt;/div&gt;&lt;div&gt;&lt;footer id=&quot;footer&quot; style=&quot;width: 1017.33px&quot;&gt;&lt;/footer&gt;&lt;/div&gt;",
      "options_type_display": "Button",
      "page_name": "Outworker assessment - (Schedule 1 â€“ Clause 1A 1998 Act)",
      "question": "Does the person perform work as an outworker (under a contract or arrangement)?",
      "question_summary": "",
      "explanatory_content": "&lt;p&gt;Definition of an outworker:&lt;/p&gt;&lt;p&gt;A person to whom articles or materials are given to be made, cleaned, washed, altered, ornamented, finished, adapted for sale in the person&#039;s own home or on other premises not under the control or management of the person who gave out the articles or materials. Please refer to Deemed Worker Provisions, &lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.1A&quot;&gt;Schedule 1 &amp;ndash; Clause 1A of the 1998 Act&lt;/a&gt;.&lt;/p&gt;",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1089935",
      "children": [
        "1089945",
        "1088904"
      ]
    },
    "1089945": {
      "id": "1089945",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.1-p48/9.1.2-p49",
      "asset_name": "9.1.1 (P49)",
      "complete_name": "9.1.2 (P49) Outworker assessment - step 2",
      "reference": "9.1.2 (P49)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Outworker assessment - step 2",
      "question": "Does the person subcontract or employ a third person?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1089941",
      "children": [
        "1088340",
        "1088372"
      ]
    },
    "1090103": {
      "id": "1090103",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.4",
      "asset_name": "4.1.4",
      "complete_name": "4.1.4  D)None of the above",
      "reference": "4.1.4",
      "option_displayed_on_parent": "No, the individual person performing work does not fall into any of the above categories.",
      "option_displayed_on_parent_tooltip": "&lt;h2&gt;Natural person&lt;/h2&gt;&lt;p&gt;A natural person is a human being, not a legal entity created by law. Examples of a natural person include:&lt;/p&gt;&lt;ul&gt;&lt;li&gt;a sole trader&lt;/li&gt;&lt;li&gt;a named individual trustee of a trust (as opposed to a company or incorporated entity being the trustee of the trust)&lt;/li&gt;&lt;li&gt;an individual person working for another person, or for a partnership, or for an entity (an entity being an incorporated trustee or an incorporated entity: that is, a Proprietary Limited (Pty Ltd) company).&lt;/li&gt;&lt;/ul&gt;",
      "options_type_display": "Button",
      "page_name": "D) None of the above",
      "question": "Is the person performing work engaged under the following deeming provisions.",
      "question_summary": "Is the individual person performing work engaged under the following deeming provisions.",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1085611",
      "children": [
        "1095814"
      ]
    },
    "1095109": {
      "id": "1095109",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/1.2-p5",
      "asset_name": "1.2 (P5) Exit: Only for employers / principal contractors",
      "complete_name": "1.2 (P5) Exit: Only for employers / principal contractors",
      "reference": "1.2 (P5)",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Exit: Only for employers / principal contractors",
      "question": "The tool is not designed for use by workers nor insurers for determining either claims eligibility nor liability.",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1085574"
    },
    "1095220": {
      "id": "1095220",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.4/7.0-p53/7.1-p55/7.1.1-p56/8.11-p57",
      "asset_name": "8.11 (P57)",
      "complete_name": "8.11 (P57) Contractor results page",
      "reference": "8.11 (P57)",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Contractor results page",
      "question": "Our guidance: Contractor (Not a worker or a deemed worker)",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1088352"
    },
    "1095268": {
      "id": "1095268",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.2-p63",
      "asset_name": "9.2 (P63)",
      "complete_name": "9.2 (P63) Contractors under labour hire service arrangement",
      "reference": "9.2 (P63)",
      "option_displayed_on_parent": "Contractors under labour hire service arrangement",
      "option_displayed_on_parent_tooltip": "&lt;p&gt;The legislation relevant to contractors under a labour hire agreement is &lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.2A&quot; target=&quot;_blank&quot;&gt;Clause 2A&lt;/a&gt; of the&amp;nbsp;&lt;em&gt;Workplace Injury Management and Workers Compensation Act 1998. &lt;/em&gt;An excerpt from the Act is below.&lt;/p&gt;&lt;h3&gt;2A Contractors under labour hire services arrangements&lt;/h3&gt;&lt;p&gt;(1)&amp;nbsp;&amp;nbsp;In this clause&amp;mdash;&lt;/p&gt;&lt;p&gt;labour hire services contract means a contract or arrangement (not being a contract of service or a training contract) under which a person is provided with services to facilitate the performance of work by the person, such as the following services&amp;mdash;&lt;/p&gt;&lt;p&gt;(a)&amp;nbsp;&amp;nbsp;services for finding work for the person,&lt;/p&gt;&lt;p&gt;(b)&amp;nbsp;&amp;nbsp;services for payment for work performed by the person,&lt;/p&gt;&lt;p&gt;(c)&amp;nbsp;&amp;nbsp;services for insurance coverage in connection with any such work.&lt;/p&gt;&lt;p&gt;(2)&amp;nbsp;&amp;nbsp;If&amp;mdash;&lt;/p&gt;&lt;p&gt;(a)&amp;nbsp;&amp;nbsp;a person (a labour hire agency) under a labour hire services contract with another person (a contractor) arranges for the contractor to perform work for a third person (the host employer), and&lt;/p&gt;&lt;p&gt;(b)&amp;nbsp;&amp;nbsp;the work performed is not incidental to a trade or business regularly carried on by the contractor in the contractor&amp;rsquo;s own name or under a business or firm name, and&lt;/p&gt;&lt;p&gt;(c)&amp;nbsp;&amp;nbsp;the contractor neither employs any worker, nor subcontracts with any person, to perform any of that work, and&lt;/p&gt;&lt;p&gt;(d)&amp;nbsp;&amp;nbsp;the labour hire agency provides services to the contractor under the labour hire services contract during the performance of that work,&lt;/p&gt;&lt;p&gt;the contractor is, for the purposes of this Act, taken to be a worker employed by the labour hire agency while performing that work.&lt;/p&gt;&lt;p&gt;(3)&amp;nbsp;&amp;nbsp;For the avoidance of doubt, this clause applies&amp;mdash;&lt;/p&gt;&lt;p&gt;(a)&amp;nbsp;&amp;nbsp;where a labour hire agency and a host employer are related bodies corporate, and&lt;/p&gt;&lt;p&gt;(b)&amp;nbsp;&amp;nbsp;in addition to any other provisions of this Act relating to the employment of workers.&lt;/p&gt;",
      "options_type_display": "Button",
      "page_name": "Contractors under labour hire service arrangement",
      "question": "Is there a labour hire service contract where a labour hire agency arranges for the contractor to perform work for a host employer?",
      "question_summary": "",
      "explanatory_content": "&lt;h4&gt;Note 1:&lt;/h4&gt;&lt;p&gt;A labour hire service contract relates to services to facilitate:&lt;/p&gt;&lt;p&gt;(a) finding work for the person,&lt;/p&gt;&lt;p&gt;(b) payment for work performed by the person,&lt;/p&gt;&lt;p&gt;(c) insurance coverage in connection with any such work.&lt;/p&gt;&lt;p&gt;It also applies when:&lt;/p&gt;&lt;p&gt;d) the labour hire company and host company are related bodies corporate.&lt;/p&gt;",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1089935",
      "children": [
        "1095272",
        "1088904"
      ]
    },
    "1095272": {
      "id": "1095272",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.2-p63/9.2.1-p65",
      "asset_name": "9.2.1 (P65)",
      "complete_name": "9.2.1 (P65) Subcontract or employ other worker",
      "reference": "9.2.1 (P65)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Subcontract or employ other worker",
      "question": "Does the person subcontract or employ any other worker?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095268",
      "children": [
        "1088340",
        "1095276"
      ]
    },
    "1095276": {
      "id": "1095276",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.2-p63/9.2.1-p65/9.2.1.1-p67",
      "asset_name": "9.2.1.1 (P67)",
      "complete_name": "9.2.1.1 (P67) Own business or trade",
      "reference": "9.2.1.1 (P67)",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Own business or trade",
      "question": "Does the person performing work regularly carry on their own business or trade?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095272",
      "children": [
        "1095292",
        "1095309"
      ]
    },
    "1095292": {
      "id": "1095292",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.2-p63/9.2.1-p65/9.2.1.1-p67/9.2.1.1.1-p68",
      "asset_name": "9.2.1.1.1 (P68)",
      "complete_name": "9.2.1.1.1 (P68) Contract work different to own business",
      "reference": "9.2.1.1.1 (P68)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Contract work different to own business",
      "question": "Is the work performed under the contract different and not incidental to the normal business or trade of the person?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095276",
      "children": [
        "1095299",
        "1088904"
      ]
    },
    "1095299": {
      "id": "1095299",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.2-p63/9.2.1-p65/9.2.1.1-p67/9.2.1.1.1-p68/9.1.1-p70",
      "asset_name": "9.1.1 (P70) ",
      "complete_name": "9.1.1 (P70) Labour hire services",
      "reference": "9.1.1 (P70)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Labour hire services",
      "question": "Does the labour hire company provide services to the contractor under the labour hire service contract during the performance of that work?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095292",
      "children": [
        "1095303",
        "1088904"
      ]
    },
    "1095303": {
      "id": "1095303",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.2-p63/9.2.1-p65/9.2.1.1-p67/9.1.9-p70/8.184-p71",
      "asset_name": "8.184 (P71)",
      "complete_name": "8.184 (P71) Deemed worker labour hire service arrangements results page",
      "reference": "8.184 (P71)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Deemed worker labour hire service arrangements results page",
      "question": "Our Guidance: Deemed Worker",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095309"
    },
    "1095309": {
      "id": "1095309",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.2-p63/9.2.1-p65/9.2.1.1-p67/9.1.9-p70",
      "asset_name": "9.1.9 (P70)",
      "complete_name": "9.1.9 (P70) Labour hire services",
      "reference": "9.1.9 (P70)",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Labour hire services",
      "question": "Does the labour hire company provide services to the contractor under the labour hire service contract during the performance of that work?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095276",
      "children": [
        "1095303",
        "1088904"
      ]
    },
    "1095354": {
      "id": "1095354",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.3-p73",
      "asset_name": "9.3 (P73)",
      "complete_name": "9.3 (P73) Rural work assessment - step 1",
      "reference": "9.3 (P73)",
      "option_displayed_on_parent": "Rural work",
      "option_displayed_on_parent_tooltip": "&lt;p&gt;The legislation relevant to rural work is &lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.3&quot; target=&quot;_blank&quot;&gt;Clause 3&lt;/a&gt; of the &lt;em&gt;Workplace Injury Management and Workers Compensation Act 1998&lt;/em&gt;.&amp;nbsp;&amp;nbsp;An excerpt from the Act is below.&lt;/p&gt;&lt;h3&gt;3 Rural work&lt;/h3&gt;&lt;p&gt;(cf former Sch 1 cl 3)&lt;/p&gt;&lt;p&gt;(1)&amp;nbsp;&amp;nbsp;This clause applies to the following work&amp;mdash;&lt;/p&gt;&lt;p&gt;(a)&amp;nbsp;&amp;nbsp;The work of supplying timber, if the timber is obtained, or is to be obtained, from trees felled, or to be felled, by a contractor (whether the trees are the property of the principal or the contractor or any other person).&lt;/p&gt;&lt;p&gt;(b)&amp;nbsp;&amp;nbsp;The work of felling or ringbarking trees, or cutting scrub, or hauling or loading timber.&lt;/p&gt;&lt;p&gt;(c)&amp;nbsp;&amp;nbsp;The work of clearing land of stumps or logs.&lt;/p&gt;&lt;p&gt;(d)&amp;nbsp;&amp;nbsp;The work of cutting sugar cane.&lt;/p&gt;&lt;p&gt;(e)&amp;nbsp;&amp;nbsp;The work of erecting, constructing or demolishing or assisting in the erection, construction or demolition of&amp;mdash;&lt;/p&gt;&lt;p&gt;(i)&amp;nbsp;&amp;nbsp;fences, or&lt;/p&gt;&lt;p&gt;(ii)&amp;nbsp;&amp;nbsp;yards or enclosures for horses, cattle, sheep or other animals,&lt;/p&gt;&lt;p&gt;on farms, orchards, vineyards or agricultural or pastoral holdings.&lt;/p&gt;&lt;p&gt;(f)&amp;nbsp;&amp;nbsp;All classes of work normally carried out or performed by derrick operators in or in connection with the transport of sugar cane to a mill.&lt;/p&gt;&lt;p&gt;(g)&amp;nbsp;&amp;nbsp;Any other class of work prescribed by the regulations.&lt;/p&gt;&lt;p&gt;(2)&amp;nbsp;&amp;nbsp;If&amp;mdash;&lt;/p&gt;&lt;p&gt;(a)&amp;nbsp;&amp;nbsp;any person (in this clause referred to as&amp;nbsp;the principal) in the course of, or for the purposes of, the person&amp;rsquo;s trade or business enters into a contract, agreement or arrangement with any other person (in this clause referred to as&amp;nbsp;the contractor) under which the contractor agrees to carry out work to which this clause applies, and&lt;/p&gt;&lt;p&gt;(b)&amp;nbsp;&amp;nbsp;the contractor&amp;mdash;&lt;/p&gt;&lt;p&gt;(i)&amp;nbsp;&amp;nbsp;does not either sublet any part of the work to be carried out, or employ a worker, or&lt;/p&gt;&lt;p&gt;(ii)&amp;nbsp;&amp;nbsp;(although either subletting part of the work or employing a worker) actually performs some part of the work himself or herself,&lt;/p&gt;&lt;p&gt;the contractor and any worker so employed by the contractor are, for the purposes of this Act, taken to be workers employed by the principal, and a worker so employed by the contractor is, for the purposes of this Act, other than this clause, taken not to be a worker employed by the contractor.&lt;/p&gt;&lt;p&gt;(3)&amp;nbsp;&amp;nbsp;If the principal has given or offered the contractor the option to or the opportunity to so supply timber if the contractor so desires, then, for the purposes of this clause, the contractor is taken to have agreed to supply timber.&lt;/p&gt;&lt;p&gt;(4)&amp;nbsp;&amp;nbsp;This clause does not apply to or in respect of a contract, agreement or arrangement to haul or load timber if the timber has been subjected to a manufacturing process as defined by the&amp;nbsp;&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/repealed/current/act-1962-043&quot;&gt;Factories, Shops and Industries Act 1962&lt;/a&gt; in a factory as defined by that Act.&lt;/p&gt;&lt;p&gt;(5)&amp;nbsp;&amp;nbsp;All the principals by whom a person is taken to be employed under this clause at the time of an injury to the person are liable to contribute to any compensation payable under this Act in respect of the injury in such proportion as, in default of agreement, the Commission determines.&lt;/p&gt;&lt;p&gt;(6)&amp;nbsp;&amp;nbsp;For the purposes of this Act, a notice of injury given by a person employed by the contractor is taken to be given to the employer if it is given either to the contractor or the principal.&lt;/p&gt;&lt;p&gt;(7)&amp;nbsp;&amp;nbsp;The contractor must, on request, inform a person employed by the contractor of the name and address of the principal.&lt;/p&gt;&lt;p&gt;(8)&amp;nbsp;&amp;nbsp;In this clause&amp;mdash;&lt;/p&gt;&lt;p&gt;timber includes sleepers, piles, poles and logs.&lt;/p&gt;",
      "options_type_display": "Button",
      "page_name": "Rural work assessment - step 1",
      "question": "Does the person conduct any of these activities:",
      "question_summary": "Does the person conduct any of these activities: 1) Supply timber, or 2) Fell or ring bark trees, cut scrub or haul or load timber, or 3) Clear land of stumps or logs, or 4) Cut sugar cane, or 5) Direct, contract or demolish fences, yards or enclosures for horses/cattle/sheep or other animals, or 6) Carry on work performed by derrick operators or transport of sugarcane to the mill.",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1089935",
      "children": [
        "1095359",
        "1088904"
      ]
    },
    "1095359": {
      "id": "1095359",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.3-p73/9.3.1-p75",
      "asset_name": "9.3.1 (P75)",
      "complete_name": "9.3.1 (P75) Rural work assessment - step 2",
      "reference": "9.3.1 (P75)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Rural work assessment - step 2",
      "question": "Does the person subcontract or engage another person to the work?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095354",
      "children": [
        "1095363",
        "1095375"
      ]
    },
    "1095363": {
      "id": "1095363",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.3-p73/9.3.1-p75/9.3.1.1-p77",
      "asset_name": "9.3.1.1 (P77)",
      "complete_name": "9.3.1.1 (P77) Rural work assessment - step 3",
      "reference": "9.3.1.1 (P77)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Rural work assessment - step 3",
      "question": "If subletting or engaging a 3rd person, does the person perform some of the work themselves?",
      "question_summary": "If subletting or engaging a third person, does the person perform some of the work themselves?",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095359",
      "children": [
        "1095367",
        "1088904"
      ]
    },
    "1095367": {
      "id": "1095367",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.3-p73/9.3.1-p75/9.3.1.1-p77/8.218-p76",
      "asset_name": "8.218 (P76)",
      "complete_name": "8.218 (P76) Deemed worker - rural work results page",
      "reference": "8.218 (P76)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Deemed worker - rural work results page",
      "question": "Our Guidance: Deemed Worker",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095363"
    },
    "1095375": {
      "id": "1095375",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.3-p73/9.3.1-p75/8.227-p76",
      "asset_name": "8.227 (P76)",
      "complete_name": "8.227 (P76) Deemed worker - rural work results page",
      "reference": "8.227 (P76)",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Deemed worker - rural work results page",
      "question": "Our Guidance: Deemed Worker",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095359"
    },
    "1095384": {
      "id": "1095384",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.4-p80",
      "asset_name": "9.4 (P80)",
      "complete_name": "9.4 (P80) Timbergetters (Place advertisement)",
      "reference": "9.4 (P80)",
      "option_displayed_on_parent": "Timbergetters (Place advertisement)",
      "option_displayed_on_parent_tooltip": "&lt;p&gt;The legislation relevant to timbergetters is&amp;nbsp;&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.4&quot; target=&quot;_blank&quot;&gt;Clause 4&lt;/a&gt; of the &lt;em&gt;Workplace Injury Management and Workers Compensation Act 1998&lt;/em&gt;. An excerpt from the Act is below.&lt;/p&gt;&lt;h3&gt;4 Timbergetters&lt;/h3&gt;&lt;p&gt;(cf former Sch 1 cl 4)&lt;/p&gt;&lt;p&gt;(1)&amp;nbsp;&amp;nbsp;If any person (in this clause referred to as&amp;nbsp;the principal) advertises or otherwise notifies that he or she will accept timber delivered or supplied in accordance with the advertisement or notification, any person who gives notice to the principal that he or she will deliver or supply the timber or any part of the timber is, for the purposes of this Act, taken to be a worker employed by the principal.&lt;/p&gt;&lt;p&gt;(2)&amp;nbsp;&amp;nbsp;Notice of intention to deliver or supply timber&amp;mdash;&lt;/p&gt;&lt;p&gt;(a)&amp;nbsp;&amp;nbsp;must indicate the nature of the actual work to be undertaken, and&lt;/p&gt;&lt;p&gt;(b)&amp;nbsp;&amp;nbsp;must be given prior to injury.&lt;/p&gt;&lt;p&gt;(3)&amp;nbsp;&amp;nbsp;All the principals by whom a person is taken to be employed under this clause at the time of an injury to the person are liable to contribute to any compensation payable under this Act in respect of the injury in such proportion as, in default of agreement, the Commission determines.&lt;/p&gt;&lt;p&gt;(4)&amp;nbsp;&amp;nbsp;In this clause&amp;mdash;&lt;/p&gt;&lt;p&gt;timber includes sleepers, piles, poles and logs.&lt;/p&gt;",
      "options_type_display": "Button",
      "page_name": "Timbergetters (Place advertisement)",
      "question": "As the principal, did you place an advertisement or notice that you will accept the supply of timber eg sleepers, piles, poles or logs?",
      "question_summary": "As the principal, did you place an advertisement or notice that you will accept the supply of timber e.g. sleepers, piles, poles or logs?",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1089935",
      "children": [
        "1095388",
        "1095398"
      ]
    },
    "1095388": {
      "id": "1095388",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.4-p80/9.4.1-p80",
      "asset_name": "9.4.1 (P80)",
      "complete_name": "9.4.1 (P80) Timbergetters - (Response to advertisement)",
      "reference": "9.4.1 (P80)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Timbergetters - (Response to advertisement)",
      "question": "As the principal, were you given notice by the supplier/person performing the work that they will supply or deliver the timber in response to your advertisement or notice?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095384",
      "children": [
        "1095392",
        "1095398"
      ]
    },
    "1095392": {
      "id": "1095392",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.4-p80/9.4.1-p80/8.236-p81",
      "asset_name": "8.236 (P81)",
      "complete_name": "8.236 (P81) Deemed worker - timbergetters results page",
      "reference": "8.236 (P81)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Deemed worker - timbergetters results page",
      "question": "Our Guidance: Deemed Worker",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095388"
    },
    "1095398": {
      "id": "1095398",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.4-p80/9.4.1.1",
      "asset_name": "9.4.1.1",
      "complete_name": "9.4.1.1 Fell and supply timer themselves",
      "reference": "9.4.1.1",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Fell and supply timer themselves",
      "question": "Will the person performing the work fell timber themselves and supply it to you?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095384",
      "children": [
        "1095412",
        "1088904"
      ]
    },
    "1095412": {
      "id": "1095412",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.4-p80/9.4.1.1/9.3-p73",
      "asset_name": "9.3 (P73)",
      "complete_name": "9.3 (P73) Rural work assessment - step 1",
      "reference": "9.3 (P73)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Rural work assessment - step 1",
      "question": "Does the person conduct any of these activities:",
      "question_summary": "Does the person conduct any of these activities: 1) Supply timber, or 2) Fell or ring bark trees, cut scrub or haul or load timber, or 3) Clear land of stumps or logs, or 4) Cut sugar cane, or 5) Direct, contract or demolish fences, yards or enclosures for horses/cattle/sheep or other animals, or 6) Carry on work performed by derrick operators or transport of sugarcane to the mill.",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095398",
      "children": [
        "1095359",
        "1088904"
      ]
    },
    "1095424": {
      "id": "1095424",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.5-p83",
      "asset_name": "9.5 (P83)",
      "complete_name": "9.5 (P83) Salespersons, canvassers and others",
      "reference": "9.5 (P83)",
      "option_displayed_on_parent": "Salespersons, canvassers and others",
      "option_displayed_on_parent_tooltip": "&lt;p&gt;The legislation relevant to salespersons, canvassers and others is &lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.5&quot; target=&quot;_blank&quot;&gt;Clause 5&lt;/a&gt; of the&lt;em&gt; Workplace Injury Management and Workers Compensation Act 1998. &lt;/em&gt;An excerpt from the Act is below.&lt;/p&gt;&lt;h3&gt;5 Salespersons, canvassers, collectors and others&lt;/h3&gt;&lt;p&gt;(cf former Sch 1 cl 5)&lt;/p&gt;&lt;p&gt;(1)&amp;nbsp;&amp;nbsp;A salesperson, canvasser, collector or other person paid wholly or partly by commission is, for the purposes of this Act, taken to be a worker in the employment of the person by whom the commission is payable, unless the commission is received for or in connection with work incidental to a trade or business regularly carried on by the salesperson, canvasser, collector or other person or by a firm of which he or she is a member.&lt;/p&gt;&lt;p&gt;(2)&amp;nbsp;&amp;nbsp;All the employers who engaged any such salesperson, canvasser, collector or other person at the time of an injury to the salesperson, canvasser, collector or other person are liable to contribute to any compensation payable under this Act in respect of the injury in such proportion as, in default of agreement, the Commission determines.&lt;/p&gt;",
      "options_type_display": "Button",
      "page_name": "Salespersons, canvassers and others",
      "question": "Is the sales person, canvasser or other person paid wholly or partly by commission?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1089935",
      "children": [
        "1095430",
        "1088904"
      ]
    },
    "1095430": {
      "id": "1095430",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.5-p83/9.5.1-p83",
      "asset_name": "9.5.1 (P83)",
      "complete_name": "9.5.1 (P83) Salespersons, canvassers and other - Run their own business",
      "reference": "9.5.1 (P83)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Salespersons, canvassers and other - Run their own business",
      "question": "Does the sales person, canvasser or other person run his/her own business?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095424",
      "children": [
        "1095434",
        "1095438"
      ]
    },
    "1095434": {
      "id": "1095434",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.5-p83/9.5.1-p83/9.5.2-p85",
      "asset_name": "9.5.2 (P85)",
      "complete_name": "9.5.2 (P85) Sales and canvassing is different to their own business",
      "reference": "9.5.2 (P85)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Sales and canvassing is different to their own business",
      "question": "Is the commission earned by performing the sales or canvassing work for you, different to the type of work carried on by the person in their own business?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095430",
      "children": [
        "1095444",
        "1088904"
      ]
    },
    "1095438": {
      "id": "1095438",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.5-p83/9.5.1-p83/8.298-p84",
      "asset_name": "8.298 (P84)",
      "complete_name": "8.298 (P84) Deemed worker - salesperson, canvasser and others results page",
      "reference": "8.298 (P84)",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Deemed worker - salesperson, canvasser and others results page",
      "question": "Our Guidance: Deemed worker",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095430"
    },
    "1095444": {
      "id": "1095444",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.5-p83/9.5.1-p83/9.5.2-p85/8.289-p86",
      "asset_name": "8.289 (P86)",
      "complete_name": "8.289 (P86) Deemed worker - sales and canvassing results page",
      "reference": "8.289 (P86)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Deemed worker - sales and canvassing results page",
      "question": "Our Guidance: Deemed worker",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095434"
    },
    "1095450": {
      "id": "1095450",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.6-p88",
      "asset_name": "9.6 (P88)",
      "complete_name": "9.6 (P88) Tributers",
      "reference": "9.6 (P88)",
      "option_displayed_on_parent": "Tributers",
      "option_displayed_on_parent_tooltip": "&lt;p&gt;The legislation relevant to tributers is &lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.6&quot; target=&quot;_blank&quot;&gt;Clause 6&lt;/a&gt; of the&lt;em&gt; Workplace Injury Management and Workers Compensation Act 1998. &lt;/em&gt;An excerpt is below.&lt;/p&gt;&lt;h3&gt;6 Tributers&lt;/h3&gt;&lt;p&gt;(cf former Sch 1 cl 6)&lt;/p&gt;&lt;p&gt;A tributer working in connection with any mine (as defined in the&amp;nbsp;&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1992-029&quot; target=&quot;_blank&quot;&gt;Mining Act 1992&lt;/a&gt;) and also any workers employed by any such tributer are, for the purposes of this Act, taken to be workers employed by the person with whom the tribute agreement was made by the tributer.&lt;/p&gt;",
      "options_type_display": "Button",
      "page_name": "Tributers",
      "question": "Is the person a tributer or a worker employed by the tributer working in connection with a mine under the Mining Act 1992?",
      "question_summary": "",
      "explanatory_content": "&lt;p&gt;* A tributer is a person who works a mine or a portion of a mine under an agreement with the lessee, claimholder or proprietor to pay to or receive from such titleholder, a proportion or percentage of the produce of the mine (or of the value of such produce). Workers employed by a tributer are also considered to be tributers.&lt;/p&gt;",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1089935",
      "children": [
        "1095454",
        "1088904"
      ]
    },
    "1095454": {
      "id": "1095454",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.6-p88/8.307-p89",
      "asset_name": "8.307 (P89)",
      "complete_name": "8.307 (P89) Deemed worker tributer results page",
      "reference": "8.307 (P89)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Deemed worker tributer results page",
      "question": "Our Guidance: Deemed worker of the person with whom the tributer* made the tribute agreement",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095450"
    },
    "1095460": {
      "id": "1095460",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.7-p91",
      "asset_name": "9.7 (P91)",
      "complete_name": "9.7 (P91) Mine employees",
      "reference": "9.7 (P91)",
      "option_displayed_on_parent": "Mine employees",
      "option_displayed_on_parent_tooltip": "&lt;p&gt;The legislation relevant to mine employees is &lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.7&quot; target=&quot;_blank&quot;&gt;Clause 7&lt;/a&gt; of the&lt;em&gt; Workplace Injury Management and Workers Compensation Act 1998. &lt;/em&gt;An excerpt from the Act is below.&lt;/p&gt;&lt;h3&gt;7 Mine employees&lt;/h3&gt;&lt;p&gt;(cf former Sch 1 cl 7)&lt;/p&gt;&lt;p&gt;Any person usually employed about a mine or in connection with the operations of a mine whose remuneration is provided wholly or partly by the workers employed at the mine is, for the purposes of this Act, taken to be a worker employed by the person by or for whom the mine is being worked.&lt;/p&gt;",
      "options_type_display": "Button",
      "page_name": "Mine employees",
      "question": "Is the person employed in a mine, or in connection with the operation of a mine, whose remuneration is wholly or partly paid by the workers employed at the mine?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1089935",
      "children": [
        "1095503",
        "1088904"
      ]
    },
    "1095503": {
      "id": "1095503",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.7-p91/8.316-p92",
      "asset_name": "8.316 (P92)",
      "complete_name": "8.316 (P92) Deemed Worker - Mine employee results page",
      "reference": "8.316 (P92)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Deemed Worker - Mine employee results page",
      "question": "Our Guidance: Deemed worker",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095460"
    },
    "1095509": {
      "id": "1095509",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.8-p94",
      "asset_name": "9.8 (P94)",
      "complete_name": "9.8 (P94) Mine rescue personnel",
      "reference": "9.8 (P94)",
      "option_displayed_on_parent": "Mine rescue personnel",
      "option_displayed_on_parent_tooltip": "&lt;p&gt;The legislation relevant to mine rescue personnel is &lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.8&quot; target=&quot;_blank&quot;&gt;Clause 8&lt;/a&gt; of the&amp;nbsp;&lt;em&gt;Workplace Injury Management and Workers Compensation Act 1998. &lt;/em&gt;An exerpt from the Act is below.&lt;/p&gt;&lt;h3&gt;8 Mines rescue personnel&lt;/h3&gt;&lt;p&gt;(cf former Sch 1 cl 8)&lt;/p&gt;&lt;p&gt;(1)&amp;nbsp;&amp;nbsp;For the purposes of this Act&amp;mdash;&lt;/p&gt;&lt;p&gt;(a)&amp;nbsp;&amp;nbsp;a member of the New South Wales Mines Rescue Brigade engaged in mine rescue work, or undergoing training, in accordance with Part 4 of the&amp;nbsp;&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-2001-107&quot; target=&quot;_blank&quot;&gt;Coal Industry Act 2001&lt;/a&gt; is, while so engaged or undergoing training, taken to be a worker employed by the mines rescue company, and&lt;/p&gt;&lt;p&gt;(b)&amp;nbsp;&amp;nbsp;a place at which such a member is so engaged or undergoing training is taken to be a place at which the member is employed.&lt;/p&gt;&lt;p&gt;(2)&amp;nbsp;&amp;nbsp;A member of the New South Wales Mines Rescue Brigade who receives an injury while journeying between the place from which the member was required to attend for the purpose of engaging in mine rescue work or of undergoing training and a place referred to in subclause (1) (b) is, if the journeying was exclusively and genuinely for that purpose, entitled to receive compensation in accordance with this Act from the mines rescue company.&lt;/p&gt;&lt;p&gt;(3)&amp;nbsp;&amp;nbsp;In this clause,&amp;nbsp;mines rescue company means the mines rescue company within the meaning of the&amp;nbsp;&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-2001-107&quot; target=&quot;_blank&quot;&gt;Coal Industry Act 2001&lt;/a&gt;.&lt;/p&gt;",
      "options_type_display": "Button",
      "page_name": "Mine rescue personnel",
      "question": "Is the person a member of the NSW Mine Rescue Brigade engaged in mine rescue work or undergoing training as per the Coal Industry Act?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1089935",
      "children": [
        "1095514",
        "1088904"
      ]
    },
    "1095514": {
      "id": "1095514",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.8-p94/8.325-p95",
      "asset_name": "8.325 (P95)",
      "complete_name": "8.325 (P95) Deemed Worker - Mine rescue personnel results page",
      "reference": "8.325 (P95)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Deemed Worker - Mine rescue personnel results page",
      "question": "Our Guidance: Deemed worker",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095509"
    },
    "1095526": {
      "id": "1095526",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.9-p97",
      "asset_name": "9.9 (P97)",
      "complete_name": "9.9 (P97) Jockeys and harness racing drivers",
      "reference": "9.9 (P97)",
      "option_displayed_on_parent": "Jockeys and harness racing drivers",
      "option_displayed_on_parent_tooltip": "&lt;p&gt;The legislation relevant to jockeys and harness racing drivers is &lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.9&quot; target=&quot;_blank&quot;&gt;Clause 9&lt;/a&gt; of the&amp;nbsp;&lt;em&gt;Workplace Injury Management and Workers Compensation Act 1998.&amp;nbsp;&amp;nbsp;&lt;/em&gt;An excerpt is below.&lt;/p&gt;&lt;h3&gt;9 Jockeys and harness racing drivers&lt;/h3&gt;&lt;p&gt;(cf former Sch 1 cl 9)&lt;/p&gt;&lt;p&gt;(1)&amp;nbsp;&amp;nbsp;A person who&amp;mdash;&lt;/p&gt;&lt;p&gt;(a)&amp;nbsp;&amp;nbsp;is engaged to ride a horse for fee or reward at a meeting for horse racing conducted or held by a racing club or association, or&lt;/p&gt;&lt;p&gt;(b)&amp;nbsp;&amp;nbsp;drives a horse at a meeting for harness racing conducted or held by a racing club or association and at which betting is allowed, or&lt;/p&gt;&lt;p&gt;(c)&amp;nbsp;&amp;nbsp;is engaged in riding work in connection with horse racing (but not harness racing) on the racecourse or other premises of a racing club or association,&lt;/p&gt;&lt;p&gt;is, for the purposes of this Act, taken to be a worker employed by the racing club or association.&lt;/p&gt;&lt;p&gt;(2)&amp;nbsp;&amp;nbsp;Subclause (1) does not apply to a racing club or association having its headquarters in a town with a population not exceeding 3,000 people if&amp;mdash;&lt;/p&gt;&lt;p&gt;(a)&amp;nbsp;&amp;nbsp;the meetings of the racing club or association are conducted or held within a radius of 8 kilometres from the town, and&lt;/p&gt;&lt;p&gt;(b)&amp;nbsp;&amp;nbsp;the profits derived from the operations of the racing club or association are applied for charitable purposes.&lt;/p&gt;&lt;p&gt;(3)&amp;nbsp;&amp;nbsp;For the purpose of assessing the compensation payable to a person to whom this clause applies, the &amp;ldquo;average weekly earnings&amp;rdquo; of the person are&amp;mdash;&lt;/p&gt;&lt;p&gt;(a)&amp;nbsp;&amp;nbsp;to be calculated in such manner (if any) as may be prescribed by the regulations, or&lt;/p&gt;&lt;p&gt;(b)&amp;nbsp;&amp;nbsp;if the person was not working under contract of service&amp;mdash;to be calculated in such manner as the Commission considers to be reasonable in the circumstances.&lt;/p&gt;&lt;p&gt;(4)&amp;nbsp;&amp;nbsp;The regulations may make provision for or with respect to the exemption of any class of persons from the operation of subclause (1) (b).&lt;/p&gt;",
      "options_type_display": "Button",
      "page_name": "Jockeys and harness racing drivers",
      "question": "As a racing club/association, are you engaging a jockey or harness racing driver or another person engaged in riding work in connection with horse racing?",
      "question_summary": "As a racing club/association, are you engaging a jockey or harness racing driver or another person engaged in riding work in connection with horse racing?",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1089935",
      "children": [
        "1095530",
        "1088904"
      ]
    },
    "1095530": {
      "id": "1095530",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.9-p97/9.9.1-p97",
      "asset_name": "9.9.1 (P97)",
      "complete_name": "9.9.1 (P97) Jockeys and harness racing drivers - conditions",
      "reference": "9.9.1 (P97)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Jockeys and harness racing drivers - conditions",
      "question": "Do any of the following apply: 1. The jockey is being engaged to ride a horse for a fee or reward at a meeting for horse racing held by a racing club or association, or 2. The harness racing driver is being engaged to drive a horse at a meeting for harness racing at which betting is allowed, or 3. The person is being engaged for riding work in connection with horse racing on the racecourse or other premises of the racing club or association.",
      "question_summary": "Do any of the following apply: 1) The jockey is being engaged to ride a horse for a fee or reward at a meeting for horse racing held by a racing club or association, or 2) The harness racing driver is being engaged to drive a horse at a meeting for harness racing at which betting is allowed, or 3) The person is being engaged for riding work in connection with horse racing on the racecourse or other premises of the racing club or association.",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095526",
      "children": [
        "1095534",
        "1088904"
      ]
    },
    "1095534": {
      "id": "1095534",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.9-p97/9.9.1-p97/8.334-p98",
      "asset_name": "8.334 (P98)",
      "complete_name": "8.334 (P98) Deemed worker of the racing club/association",
      "reference": "8.334 (P98)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Deemed worker of the racing club/association",
      "question": "Our Guidance: Deemed worker of the racing club or association",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095530"
    },
    "1095615": {
      "id": "1095615",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.10-p100",
      "asset_name": "9.10 (P100)",
      "complete_name": "9.10 (P100) Drivers of hire vehicles or hire vessels - contract of bailment",
      "reference": "9.10 (P100)",
      "option_displayed_on_parent": "Drivers of hire vehicles or hire vessels - contract of bailment",
      "option_displayed_on_parent_tooltip": "&lt;p&gt;The legislation relevant to drivers of hire vehicles or hire vessels - contract of bailment is &lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.10&quot; target=&quot;_blank&quot;&gt;Clause 10&lt;/a&gt; of the&amp;nbsp;&lt;em&gt;Workplace Injury Management and Workers Compensation Act 1998. &lt;/em&gt;An excerpt is below.&lt;/p&gt;&lt;h3&gt;10 Drivers of hire-vehicles or hire-vessels&amp;mdash;contract of bailment&lt;/h3&gt;&lt;p&gt;(cf former Sch 1 cl 10)&lt;/p&gt;&lt;p&gt;A person engaged in plying for hire with any vehicle or vessel, the use of which is obtained by that person under a contract of bailment (other than a hire purchase agreement), in consideration of the payment of a fixed sum, or a share in the earnings or otherwise, is, for the purposes of this Act, taken to be a worker employed by the person from whom the use of the vehicle or vessel is so obtained.&lt;/p&gt;",
      "options_type_display": "Button",
      "page_name": "Drivers of hire vehicles or hire vessels - contract of bailment",
      "question": "Is the person engaged in plying for hire with any vehicle or vessel under a contract of bailment â€“ for a fixed sum or share of earning? (Not hire purchase)",
      "question_summary": "Is the person engaged in plying for hire with any vehicle or vessel under a contract of bailment for a fixed sum or share of earning?",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1089935",
      "children": [
        "1095619",
        "1088904"
      ]
    },
    "1095619": {
      "id": "1095619",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.10-p100/8.351-p101",
      "asset_name": "8.351 (P101)",
      "complete_name": "8.351 (P101) Deemed Worker - Driver of the person from whom the use of the vehicle is obtained",
      "reference": "8.351 (P101)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Deemed Worker - Driver of the person from whom the use of the vehicle is obtained",
      "question": "Our Guidance: Deemed worker of the person from whom use of vehicle is obtained.",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095615"
    },
    "1095629": {
      "id": "1095629",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.11-p103",
      "asset_name": "9.11 (P103)",
      "complete_name": "9.11 (P103) Caddies and other employed through a club",
      "reference": "9.11 (P103)",
      "option_displayed_on_parent": "Caddies and other employed through a club",
      "option_displayed_on_parent_tooltip": "&lt;p&gt;The legislation relevant to&amp;nbsp;caddies and other employed through a club is &lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.11&quot; target=&quot;_blank&quot;&gt;Clause 11&lt;/a&gt; of the&amp;nbsp;&lt;em&gt;Workplace Injury Management and Workers Compensation Act 1998.&lt;/em&gt;An excerpt is below.&lt;/p&gt;&lt;h3&gt;11 Caddies and others employed through club&lt;/h3&gt;&lt;p&gt;(cf former Sch 1 cl 11)&lt;/p&gt;&lt;p&gt;A person (not being a person excluded from being a worker by reason of paragraph (d) of the definition of&amp;nbsp;worker in section 4 (1))&amp;mdash;&lt;/p&gt;&lt;p&gt;(a)&amp;nbsp;&amp;nbsp;whose employment is of a casual nature, and&lt;/p&gt;&lt;p&gt;(b)&amp;nbsp;&amp;nbsp;who is employed otherwise than for the purposes of his or her employer&amp;rsquo;s trade or business, and&lt;/p&gt;&lt;p&gt;(c)&amp;nbsp;&amp;nbsp;who is employed for the purposes of any game or recreation, and&lt;/p&gt;&lt;p&gt;(d)&amp;nbsp;&amp;nbsp;who is engaged or paid through a club,&lt;/p&gt;&lt;p&gt;is, for the purposes of this Act, taken to be a worker employed by the club.&lt;/p&gt;",
      "options_type_display": "Button",
      "page_name": "Caddies and other employed through a club",
      "question": "As a club, do you employ a person: 1. whose employment is of a casual nature, AND 2. whose type of employment, is different to his or her other employerâ€™s trade or business (where he or she is employed by another employer) AND 3. for the purpose of any game or recreation, AND 4. who is engaged or paid through the club, AND 5. not a registered participant of a sporting organisation covered by Section 4(1)(d) of the 1998 Act.",
      "question_summary": "As a club, do you employ a person: 1) whose employment is of a casual nature, and 2) whose type of employment, is different to his or her other employerâ€™s trade or business (where he or she is employed by another employer), and 3) for the purpose of any game or recreation, and 4)  who is engaged or paid through the club, and 5) not a registered participant of a sporting organisation covered by Section 4(1)(d) of the 1998 Act.",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1089935",
      "children": [
        "1095634",
        "1088904"
      ]
    },
    "1095634": {
      "id": "1095634",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.11-p103/8.360-p104",
      "asset_name": "8.360 (P104)",
      "complete_name": "8.360 (P104) Deemed worker results page - Caddies",
      "reference": "8.360 (P104)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Deemed worker results page - Caddies",
      "question": "Our Guidance: Deemed worker of the club",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095629"
    },
    "1095648": {
      "id": "1095648",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.12-p106",
      "asset_name": "9.12 (P106)",
      "complete_name": "9.12 (P106) Shearers' cooks and others",
      "reference": "9.12 (P106)",
      "option_displayed_on_parent": "Shearers' cooks and others",
      "option_displayed_on_parent_tooltip": "&lt;p&gt;The legislation relevant to&amp;nbsp;shearers&#039; cooks and others is &lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.12&quot; target=&quot;_blank&quot;&gt;Clause 12&lt;/a&gt; of the&amp;nbsp;&lt;em&gt;Workplace Injury Management and Workers Compensation Act 1998. &lt;/em&gt;An excerpt is below.&lt;/p&gt;&lt;h3&gt;12 Shearers&amp;rsquo; cooks and others&lt;/h3&gt;&lt;p&gt;(cf former Sch 1 cl 12)&lt;/p&gt;&lt;p&gt;Any person employed in connection with a pastoral or agricultural occupation, as cook, cook&amp;rsquo;s help or hut-keeper, whose remuneration is provided wholly or partly by the employees in any such occupation is, for the purposes of this Act, taken to be a worker employed by the person by or for whom the work in any such occupation is undertaken.&lt;/p&gt;",
      "options_type_display": "Button",
      "page_name": "Shearers' cooks and others",
      "question": "As a farmer or pastoralist, is there a person working as a cook, cook's helper or hut keeper in connection with your pastoral or agricultural occupation, where remuneration is wholly or partly derived from the employees of such occupation?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1089935",
      "children": [
        "1095652",
        "1088904"
      ]
    },
    "1095652": {
      "id": "1095652",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.12-p106/9.12.1-p106",
      "asset_name": "9.12.1 (P106)",
      "complete_name": "9.12.1 (P106) Shearer's cooks and other - payment",
      "reference": "9.12.1 (P106)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Shearer's cooks and other - payment",
      "question": "Is the cook, cook's helper or hut keeper wholly or partly paid by your shearers or by your other pastoral/agricultural employees?",
      "question_summary": "Is the cook, cook's helper or hut keeper wholly or partly paid by your shearers or by your other pastoral/agricultural employees?",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095648",
      "children": [
        "1095656",
        "1088904"
      ]
    },
    "1095656": {
      "id": "1095656",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.12-p106/9.12.1-p106/8.369-p107",
      "asset_name": "8.369 (P107)",
      "complete_name": "8.369 (P107) Deemed worker - shearers' cook and others results page",
      "reference": "8.369 (P107)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Deemed worker - shearers' cook and others results page",
      "question": "Our Guidance: Deemed worker of the farmer or pastoralist",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095652"
    },
    "1095662": {
      "id": "1095662",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.13-p109",
      "asset_name": "9.13 (P109)",
      "complete_name": "9.13 (P109) Fire fighters in fire districts",
      "reference": "9.13 (P109)",
      "option_displayed_on_parent": "Fire fighters in fire districts",
      "option_displayed_on_parent_tooltip": "&lt;p&gt;The legislation relevant to&amp;nbsp;fire fighters in fire districts is&amp;nbsp;&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.13&quot; target=&quot;_blank&quot;&gt;Clause 13&lt;/a&gt; of the&amp;nbsp;&lt;em&gt;Workplace Injury Management and Workers Compensation Act 1998.&lt;/em&gt;An excerpt is below.&lt;/p&gt;&lt;h3&gt;13 Fire fighters in fire districts&lt;/h3&gt;&lt;p&gt;(cf former Sch 1 cl 13)&lt;/p&gt;&lt;p&gt;(1)&amp;nbsp;&amp;nbsp;A person who (without remuneration or reward)&amp;mdash;&lt;/p&gt;&lt;p&gt;(a)&amp;nbsp;&amp;nbsp;voluntarily and without obligation engages in fighting a bush fire in any fire district constituted under the&amp;nbsp;&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1989-192&quot; target=&quot;_blank&quot;&gt;Fire and Rescue NSW Act 1989&lt;/a&gt; with the consent of or under the authority and supervision of or in co-operation with&amp;mdash;&lt;/p&gt;&lt;p&gt;(i)&amp;nbsp;&amp;nbsp;any retained fire brigade within the meaning of that Act, or&lt;/p&gt;&lt;p&gt;(ii)&amp;nbsp;&amp;nbsp;the Commissioner or any officer of Fire and Rescue NSW or any member of a permanent fire brigade, or&lt;/p&gt;&lt;p&gt;(b)&amp;nbsp;&amp;nbsp;is undergoing training for the purposes of fighting bush fires in those circumstances,&lt;/p&gt;&lt;p&gt;is, for the purposes of this Act, taken to be a worker employed in Fire and Rescue NSW.&lt;/p&gt;&lt;p&gt;(2)&amp;nbsp;&amp;nbsp;For the purposes of assessing the compensation payable to a person to whom this clause applies, the &amp;ldquo;average weekly earnings&amp;rdquo; of the person are&amp;mdash;&lt;/p&gt;&lt;p&gt;(a)&amp;nbsp;&amp;nbsp;if the person was working under a contract of service immediately before fighting the bush fire&amp;mdash;to be computed according to the earnings of the person under that contract of employment, or&lt;/p&gt;&lt;p&gt;(b)&amp;nbsp;&amp;nbsp;if the person was not working under a contract of service immediately before fighting the bush fire&amp;mdash;to be such amount as the Commission considers to be reasonable in the circumstances.&lt;/p&gt;&lt;p&gt;(3)&amp;nbsp;&amp;nbsp;In this clause&amp;mdash;&lt;/p&gt;&lt;p&gt;&lt;strong&gt;bush fire&lt;/strong&gt; means a fire burning in grass, bush, scrub or timber and any fire arising from such a fire.&lt;/p&gt;&lt;p&gt;&lt;strong&gt;fighting&lt;/strong&gt;, in relation to a bush fire, includes any reasonable act or operation performed by the person concerned at or about the scene of or in connection with a bush fire, which is necessary for, directed towards or incidental to the control or suppression of the fire or the prevention of the spread of the fire, or in any other way necessarily associated with the fire.&lt;/p&gt;",
      "options_type_display": "Button",
      "page_name": "Fire fighters in fire districts",
      "question": "As Fire and Rescue NSW, have you engaged: â€¢ a volunteer to fight a bushfire in any fire district with the consent, authority, supervision or in cooperation with a retained fire brigade, or the Commissioner, or an officer or member of the permanent fire brigade, and / or â€¢ a person to train in fighting a bushfire in any fire district in the above circumstances?",
      "question_summary": "As Fire and Rescue NSW, have you engaged: 1) a volunteer to fight a bushfire in any fire district with the consent, authority, supervision or in cooperation with a retained fire brigade, or the Commissioner, or an officer or member of the permanent fire brigade, and / or 2) a person to train in fighting a bushfire in any fire district in the above circumstances?",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1089935",
      "children": [
        "1095666",
        "1088904"
      ]
    },
    "1095666": {
      "id": "1095666",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.13-p109/8.386-p110",
      "asset_name": "8.386 (P110)",
      "complete_name": "8.386 (P110) Deemed worker - volunteer fire fighter results page",
      "reference": "8.386 (P110)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Deemed worker - volunteer fire fighter results page",
      "question": "Our Guidance: Deemed worker of Fire and Rescue NSW",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095662"
    },
    "1095672": {
      "id": "1095672",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.14-p112",
      "asset_name": "9.14 (P112)",
      "complete_name": "9.14 (P112) Workers at a place of pickup",
      "reference": "9.14 (P112)",
      "option_displayed_on_parent": "Workers at a place of pickup",
      "option_displayed_on_parent_tooltip": "&lt;p&gt;The legislation relevant to&amp;nbsp;workers at a place of pickup is&amp;nbsp;&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.14&quot; target=&quot;_blank&quot;&gt;Clause 14&lt;/a&gt; of the&lt;em&gt; Workplace Injury Management and Workers Compensation Act 1998. &lt;/em&gt;An excerpt is below.&lt;/p&gt;&lt;h3&gt;14 Workers at place of pick-up&lt;/h3&gt;&lt;p&gt;(cf former Sch 1 cl 14)&lt;/p&gt;&lt;p&gt;Where any person is ordinarily engaged in any employment in connection with which persons customarily attend certain prearranged places at which employers select and engage persons for employment, any such person is&amp;mdash;&lt;/p&gt;&lt;p&gt;(a)&amp;nbsp;&amp;nbsp;while in attendance at any such place of pick-up for the purpose of being so selected, or&lt;/p&gt;&lt;p&gt;(b)&amp;nbsp;&amp;nbsp;while travelling thereto from his or her place of abode, or&lt;/p&gt;&lt;p&gt;(c)&amp;nbsp;&amp;nbsp;where the person is not so selected, while travelling from such place of pick-up to his or her place of abode, taken to be a worker employed by the employer who last employed the person in his or her customary employment.&lt;/p&gt;",
      "options_type_display": "Button",
      "page_name": "Workers at a place of pickup",
      "question": "Does the person employed customarily attend a pre-arranged place of pickup to be selected and engaged to do work?",
      "question_summary": "",
      "explanatory_content": "&lt;p&gt;Note: If a person is not selected or engaged from the place of pickup or whilst travelling to the place of pickup, then they are a deemed worker of the previous employer until they reach their place of abode.&lt;/p&gt;",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1089935",
      "children": [
        "1104967",
        "1088904"
      ]
    },
    "1095676": {
      "id": "1095676",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.14-p112/9.14.1/8.395-p115",
      "asset_name": "8.395 (P115)",
      "complete_name": "8.395 (P115) Deemed worker of the person selecting and engaging a worker",
      "reference": "8.395 (P115)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Deemed worker of the person selecting and engaging a worker",
      "question": "Our Guidance: Deemed worker of the person selecting and engaging a worker",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1104967"
    },
    "1095683": {
      "id": "1095683",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.15-p117",
      "asset_name": "9.15 (P117)",
      "complete_name": "9.15 (P117) Boxers, wrestlers, referees and entertainers - step 1",
      "reference": "9.15 (P117)",
      "option_displayed_on_parent": "Boxers, wrestlers, referees and entertainers",
      "option_displayed_on_parent_tooltip": "&lt;p&gt;The legislation relevant to boxers, wrestlers, referees and entertainers is&amp;nbsp;&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.15&quot; target=&quot;_blank&quot;&gt;Clause 15&lt;/a&gt; of the&amp;nbsp;&lt;em&gt;Workplace Injury Management and Workers Compensation Act 1998. &lt;/em&gt;An excerpt below.&lt;/p&gt;&lt;h3&gt;15 Boxers, wrestlers, referees and entertainers&lt;/h3&gt;&lt;p&gt;(cf former Sch 1 cl 15)&lt;/p&gt;&lt;p&gt;(1)&amp;nbsp;&amp;nbsp;A person engaged for fee or reward to take part&amp;mdash;&lt;/p&gt;&lt;p&gt;(a)&amp;nbsp;&amp;nbsp;as a boxer, wrestler or referee in any public boxing or wrestling contest in a stadium or place to which the public is admitted on payment of a fee or charge, or&lt;/p&gt;&lt;p&gt;(b)&amp;nbsp;&amp;nbsp;as a boxer, wrestler or referee in any boxing or wrestling contest in or on premises subject to a club licence under the&amp;nbsp;&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-2007-090&quot; target=&quot;_blank&quot;&gt;Liquor Act 2007&lt;/a&gt;, or&lt;/p&gt;&lt;p&gt;(c)&amp;nbsp;&amp;nbsp;as an entertainer in any public performance in a place of public entertainment to which the public is admitted on payment of a fee or charge, or&lt;/p&gt;&lt;p&gt;(d)&amp;nbsp;&amp;nbsp;as an entertainer in any performance in or on premises subject to a club licence under the&amp;nbsp;&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-2007-090&quot; target=&quot;_blank&quot;&gt;Liquor Act 2007&lt;/a&gt;,&lt;/p&gt;&lt;p&gt;is, for the purposes of this Act, taken to be a worker employed by the person conducting or holding the contest or public or other performance.&lt;/p&gt;&lt;p&gt;(2)&amp;nbsp;&amp;nbsp;A person who takes part in a genuine amateur contest or performance conducted or held by a person who holds or is taken to hold an authority granted under the&amp;nbsp;&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1991-069&quot; target=&quot;_blank&quot;&gt;Charitable Fundraising Act 1991&lt;/a&gt;, is not, for the purposes of this clause, taken to be engaged for fee or reward only because a trophy or certificate is offered or awarded as a prize in the contest or performance.&lt;/p&gt;&lt;p&gt;(3)&amp;nbsp;&amp;nbsp;A person excluded from being a worker because of paragraph (d) of the definition of&amp;nbsp;worker in section 4 (1) is taken not to be a person referred to in subclause (1) (c) or (d).&lt;/p&gt;&lt;p&gt;(4)&amp;nbsp;&amp;nbsp;If 2 or more persons conduct or hold a contest or public or other performance, those persons are liable to contribute to any compensation payable under this Act for the injury in such proportion as, in default of agreement, the Commission determines.&lt;/p&gt;",
      "options_type_display": "Button",
      "page_name": "Boxers, wrestlers, referees and entertainers - step 1",
      "question": "Are you engaging a person a) As a boxer, wrestler or referee in a public boxing or wrestling contest in a stadium or place where  people are admitted on payment of a fee, or. b) As a boxer, wrestler or referee in a boxing or wrestling contest on premises subject to a club licence under the Liquor Act?",
      "question_summary": "Are you engaging a person: 1) As a boxer, wrestler or referee in a public boxing or wrestling contest in a stadium or place where people are admitted on payment of a fee, or 2) As a boxer, wrestler or referee in a boxing or wrestling contest on premises subject to a club licence under the Liquor Act?",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1089935",
      "children": [
        "1095687",
        "1095706"
      ]
    },
    "1095687": {
      "id": "1095687",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.15-p117/9.15.1",
      "asset_name": "9.15.1",
      "complete_name": "9.15.1 Boxers, wrestlers or referees - trophy or certificate only exclusion",
      "reference": "9.15.1",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Boxers, wrestlers or referees - trophy or certificate only exclusion",
      "question": "Will the boxer, wrestler or referee be awarded a trophy or certificate only (that is, there is no fee, reward, cash or other consideration), when you are holding or conducting a genuine amateur contest or performance under the Charitable Fundraising Act 1991?",
      "question_summary": "Will the boxer, wrestler or referee be awarded a trophy or certificate only (that is, there is no fee, reward, cash or other consideration), when you are holding or conducting a genuine amateur contest or performance under the Charitable Fundraising Act 1991?",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095683",
      "children": [
        "1095691",
        "1095698"
      ]
    },
    "1095691": {
      "id": "1095691",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.15-p117/9.15.1/8.404",
      "asset_name": "8.404",
      "complete_name": "8.404 Contractor results page - no fee for boxers, wrestlers and referees",
      "reference": "8.404",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Contractor results page - no fee for boxers, wrestlers and referees",
      "question": "Our guidance: Contractor (Not a worker or a deemed worker)",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095687"
    },
    "1095698": {
      "id": "1095698",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.15-p117/9.15.1/8.405-p118",
      "asset_name": "8.405 (P118)",
      "complete_name": "8.405 (P118) Deemed worker of the person holding the contest/public or other performance",
      "reference": "8.405 (P118)",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Deemed worker of the person holding the contest/public or other performance",
      "question": "Our Guidance: Deemed worker of the person holding the contest / public or other performance",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095687"
    },
    "1095706": {
      "id": "1095706",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.15-p117/9.15.2-p117",
      "asset_name": "9.15.2 (P117)",
      "complete_name": "9.15.2 (P117) Boxers, wrestlers, referees and entertainers - step 2",
      "reference": "",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "9.15.2 (P117)Boxers, wrestlers, referees and entertainers - step 2",
      "question": "Are you engaging a person for a fee or reward <tooltip: If the boxer, wrestler, or entertainer is awarded a trophy or certificate only when you are holding or conducting a genuine amateur contest or performance under the Charitable Fundraising Act 1991.>. a) A boxer, wrestler or referee in a public boxing or wrestling contest in a stadium or place where  people are admitted on payment of a fee OR. b) A boxer, wrestler or referee in a boxing or wrestling contest on premises subject to a club licence under the Liquor Act OR. c) An entertainer in a public performance in a place of public entertainment on payment of fee / charge OR. d) Entertainer in a performance on premises subject to a club licence under the Liquor Act. e) None of the above.",
      "question_summary": "Are you engaging a person for a fee or reward 1) A boxer, wrestler or referee in a public boxing or wrestling contest in a stadium or place where people are admitted on payment of a fee, or 2) A boxer, wrestler or referee in a boxing or wrestling contest on premises subject to a club licence under the Liquor Act, or 3) An entertainer in a public performance in a place of public entertainment on payment of fee / charge, or 4) An entertainer in a performance on premises subject to a club licence under the Liquor Act.",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095683",
      "children": [
        "1095710",
        "1088904"
      ]
    },
    "1095710": {
      "id": "1095710",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.15-p117/9.15.2-p117/9.15.2.1",
      "asset_name": "9.15.2.1",
      "complete_name": "9.15.2.1 Entertainers - trophy or certificate exclusions",
      "reference": "9.15.2.1",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Entertainers - trophy or certificate exclusions",
      "question": "Is the entertainer:  * awarded a trophy or certificate only (no cash or other consideration, when you are holding or conducting a genuine amateur contest or performance under the Charitable Fundraising Act 1991?  OR  * a registered participant of a sporting organisation covered by section 4(1)(d) of the 1998 Act?",
      "question_summary": "Is the entertainer: 1) Awarded a trophy or certificate only (no cash or other consideration, when you are holding or conducting a genuine amateur contest or performance under the Charitable Fundraising Act 1991, or 2) a registered participant of a sporting organisation covered by section 4(1)(d) of the 1998 Act?",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095706",
      "children": [
        "1095716",
        "1095698"
      ]
    },
    "1095716": {
      "id": "1095716",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.15-p117/9.15.2-p117/9.15.2.1/8.406",
      "asset_name": "8.406",
      "complete_name": "8.406 Contractor results page - no fee for entertainer",
      "reference": "8.406",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Contractor results page - no fee for entertainer",
      "question": "Our guidance: Contractor (Not a worker or a deemed worker)",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095710"
    },
    "1095728": {
      "id": "1095728",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.16-p120",
      "asset_name": "9.16 (P120)",
      "complete_name": "9.16 (P120) Voluntary ambulance workers",
      "reference": "9.16 (P120)",
      "option_displayed_on_parent": "Voluntary ambulance workers",
      "option_displayed_on_parent_tooltip": "&lt;p&gt;The legislation relevant to&amp;nbsp;voluntary ambulance workers is&amp;nbsp;&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.16&quot; target=&quot;_blank&quot;&gt;Clause 16&lt;/a&gt; of the&amp;nbsp;&lt;em&gt;Workplace Injury Management and Workers Compensation Act 1998. &lt;/em&gt;An excerpt is below.&lt;/p&gt;&lt;h3&gt;16 Voluntary ambulance workers&lt;/h3&gt;&lt;p&gt;(cf former Sch 1 cl 16)&lt;/p&gt;&lt;p&gt;(1)&amp;nbsp;&amp;nbsp;A person who (without remuneration or reward) voluntarily and without obligation engages in any ambulance work with the consent of or under the authority and supervision of or in co-operation with the Health Administration Corporation constituted by the&amp;nbsp;&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1982-135&quot; target=&quot;_blank&quot;&gt;Health Administration Act 1982&lt;/a&gt; is, for the purposes of this Act, taken to be a worker employed by that Corporation.&lt;/p&gt;&lt;p&gt;(2)&amp;nbsp;&amp;nbsp;For the purposes of assessing the compensation payable to a person to whom this clause applies, the &amp;ldquo;average weekly earnings&amp;rdquo; of the person are&amp;mdash;&lt;/p&gt;&lt;p&gt;(a)&amp;nbsp;&amp;nbsp;if the person was working under a contract of service immediately before engaging in the ambulance work&amp;mdash;to be computed according to the earnings of the person under that contract of employment, or&lt;/p&gt;&lt;p&gt;(b)&amp;nbsp;&amp;nbsp;if the person was not working under a contract of service immediately before engaging in the ambulance work&amp;mdash;to be such amount as the Commission considers to be reasonable in the circumstances.&lt;/p&gt;&lt;p&gt;(3)&amp;nbsp;&amp;nbsp;In this clause,&amp;nbsp;ambulance work means work in or in connection with the rendering of first aid to, or the transport of, sick or injured persons.&lt;/p&gt;",
      "options_type_display": "Button",
      "page_name": "Voluntary ambulance workers",
      "question": "Is the ambulance work conducted voluntarily (i.e. without remuneration or reward) with the consent or under authority and supervision or in co-operation with the Health Administration Corporation constituted by the Health Administration Act?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1089935",
      "children": [
        "1095732",
        "1088904"
      ]
    },
    "1095732": {
      "id": "1095732",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.16-p120/8.416-p121",
      "asset_name": "8.416 (P121)",
      "complete_name": "8.416 (P121) Deemed worker of the Health Administration Corporation results page",
      "reference": "8.416 (P121)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Deemed worker of the Health Administration Corporation results page",
      "question": "Our Guidance: Deemed worker of the Health Administration Corporation",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095728"
    },
    "1095738": {
      "id": "1095738",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.17-p123",
      "asset_name": "9.17 (P123)",
      "complete_name": "9.17 (P123) Ministers of religion",
      "reference": "9.17 (P123)",
      "option_displayed_on_parent": "Ministers of religion",
      "option_displayed_on_parent_tooltip": "&lt;p&gt;The legislation relevant to&amp;nbsp;voluntary ambulance workers is&amp;nbsp;&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.16&quot; target=&quot;_blank&quot;&gt;Clause 17&lt;/a&gt; of the&amp;nbsp;&lt;em&gt;Workplace Injury Management and Workers Compensation Act 1998. &lt;/em&gt;An excerpt is below.&lt;/p&gt;&lt;h3&gt;17 Ministers of religion&lt;/h3&gt;&lt;p&gt;(cf former Sch 1 cl 17)&lt;/p&gt;&lt;p&gt;(1)&amp;nbsp;&amp;nbsp;The regulations may declare that persons within a specified class are ministers of religion of a specified religious body or organisation.&lt;/p&gt;&lt;p&gt;(2)&amp;nbsp;&amp;nbsp;A person within such a class is, for the purposes of this Act, taken to be a worker employed by a person specified in the regulation as the employer of persons within that class.&lt;/p&gt;&lt;p&gt;(3)&amp;nbsp;&amp;nbsp;A regulation relating to a religious body or organisation may not be made except at the request of that body or organisation.&lt;/p&gt;&lt;p&gt;(4)&amp;nbsp;&amp;nbsp;An order under section 6 (14E) of the former 1926 Act, continued in force by clause 17 of Schedule 1 to the 1987 Act and in force immediately before the commencement of this clause has effect as if it were a regulation under this clause (but may be revoked by any such regulation).&lt;/p&gt;",
      "options_type_display": "Button",
      "page_name": "Ministers of religion",
      "question": "As a specified religious body or organisation, is the Minister of religion listed in &#39;Schedule 4 Ministers of religion&#39; of the Workers Compensation Regulation 2016?",
      "question_summary": "As a specified religious body or organisation, is the Minister of religion listed in Schedule 4 Ministers of religion of the Workers Compensation Regulation 2016?",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1089935",
      "children": [
        "1095742",
        "1095768"
      ]
    },
    "1095742": {
      "id": "1095742",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.17-p123/8.425-p124",
      "asset_name": "8.425 (P124)",
      "complete_name": "8.425 (P124) Deemed worker results page of the specified religious body or organisation",
      "reference": "8.425 (P124)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Deemed worker results page of the specified religious body or organisation",
      "question": "Our Guidance: Deemed worker",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095738"
    },
    "1095751": {
      "id": "1095751",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.18-p126",
      "asset_name": "9.18 (P126)",
      "complete_name": "9.18 (P126) Ministers of religion covered by policies",
      "reference": "9.18 (P126)",
      "option_displayed_on_parent": "Ministers of religion covered by policies",
      "option_displayed_on_parent_tooltip": "&lt;p&gt;The legislation relevant to&amp;nbsp;Ministers of religion covered by policies is&amp;nbsp;&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.18&quot;&gt;Clause 18&lt;/a&gt; of the&amp;nbsp;&lt;em&gt;Workplace Injury Management and Workers Compensation Act 1998. &lt;/em&gt;An excerpt is below.&lt;/p&gt;&lt;h3&gt;18 Ministers of religion covered by policies&lt;/h3&gt;&lt;p&gt;(cf former Sch 1 cl 17A)&lt;/p&gt;&lt;p&gt;(1)&amp;nbsp;&amp;nbsp;For the purposes of this Act, if a policy of insurance covers a minister of religion, that minister of religion is taken to be a worker and the person insured under the policy is taken to be the minister&amp;rsquo;s employer.&lt;/p&gt;&lt;p&gt;(2)&amp;nbsp;&amp;nbsp;A minister of religion is considered to be covered by a policy of insurance if the policy provides (whether on its own terms or in some other document recognised by or referred to in the policy) that the coverage provided by the policy extends to the minister or to ministers of a class of which that minister is a member.&lt;/p&gt;&lt;p&gt;(3)&amp;nbsp;&amp;nbsp;A religious body or organisation, and any official of the body or organisation, is taken to have an insurable interest for the purpose of enabling the body, organisation or official to obtain and maintain in force a policy of insurance that covers a minister of religion of that body or organisation.&lt;/p&gt;&lt;p&gt;(4)&amp;nbsp;&amp;nbsp;If there is a conflict between the operation of this clause and clause 17 in respect of a particular minister of religion, this clause prevails.&lt;/p&gt;&lt;p&gt;(5)&amp;nbsp;&amp;nbsp;In this clause&amp;mdash;&lt;/p&gt;&lt;p&gt;&lt;strong&gt;official &lt;/strong&gt;of a religious body or organisation includes a person or body who or which holds an office or position, or exercises official functions, within the religious body or organisation.&lt;/p&gt;",
      "options_type_display": "Button",
      "page_name": "Ministers of religion covered by policies",
      "question": "As a religious body or organisation, is your Minister of religion covered by a workers compensation insurance policy, (either as an individual, or as a member of a class of ministers)?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1089935",
      "children": [
        "1095761",
        "1088904"
      ]
    },
    "1095761": {
      "id": "1095761",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.18-p126/8.426-p127",
      "asset_name": "8.426 (P127)",
      "complete_name": "8.426 (P127) Deemed worker results page of the insured person or entity",
      "reference": "8.426 (P127)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Deemed worker results page of the insured person or entity",
      "question": "Our Guidance: Deemed worker of the insured person or entity",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095751"
    },
    "1095768": {
      "id": "1095768",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.17-p123/9.18-p126",
      "asset_name": "9.18 (P126)",
      "complete_name": "9.18 (P126) Ministers of religion covered by policies",
      "reference": "9.18 (P126)",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Ministers of religion covered by policies",
      "question": "Is the Minister of religion covered by a workers compensation insurance policy, (either as an individual, or as a member of a class of ministers)?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095738",
      "children": [
        "1095761",
        "1088904"
      ]
    },
    "1095772": {
      "id": "1095772",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.19-p129",
      "asset_name": "9.19 (P129)",
      "complete_name": "9.19 (P129) Participant in training programs",
      "reference": "9.19 (P129)",
      "option_displayed_on_parent": "Participants in training programs (not operative)",
      "option_displayed_on_parent_tooltip": "&lt;p&gt;The legislation relevant to&amp;nbsp;participants in training programs is&amp;nbsp;&lt;a href=&quot;https://legislation.nsw.gov.au/view/html/inforce/current/act-1998-086#sch.1-sec.19&quot; target=&quot;_blank&quot;&gt;Clause 19&lt;/a&gt; of the&amp;nbsp;&lt;em&gt;Workplace Injury Management and Workers Compensation Act 1998. &lt;/em&gt;An excerpt is below.&lt;/p&gt;&lt;h3&gt;19 Participants in training programs&lt;/h3&gt;&lt;p&gt;(cf former Sch 1 cl 18)&lt;/p&gt;&lt;p&gt;(1)&amp;nbsp;&amp;nbsp;The regulations may&amp;mdash;&lt;/p&gt;&lt;p&gt;(a)&amp;nbsp;&amp;nbsp;declare a specified training program that includes the provision of workplace based training and involves the provision of Commonwealth funding to be a declared training program for the purposes of this clause, and&lt;/p&gt;&lt;p&gt;(b)&amp;nbsp;&amp;nbsp;specify a class of payments as payments that are taken to be wages in respect of a participant in a declared training program.&lt;/p&gt;&lt;p&gt;(2)&amp;nbsp;&amp;nbsp;A person who is a participant in a declared training program is, for the purposes of this Act, taken to be a worker employed by the person who provides the workplace based training during any time that the person participates in the declared training program after the person who is to provide the workplace based training has entered into an agreement to provide the workplace based training.&lt;/p&gt;&lt;p&gt;(3)&amp;nbsp;&amp;nbsp;A payment that is declared by the regulations to be wages in respect of a participant in a declared training program is, for the purposes of this Act, taken to be the participant&amp;rsquo;s wages in the employment by the person who provides the workplace based training.&lt;/p&gt;&lt;p&gt;(4)&amp;nbsp;&amp;nbsp;Except to the extent that the regulations may otherwise provide, this clause does not apply in respect of participation by a person, or an injury received by a participant, in a training program before the training program became a declared training program for the purposes of this clause.&lt;/p&gt;",
      "options_type_display": "Button",
      "page_name": "Participant in training programs",
      "question": "As a provider of a workplace based training program declared under regulation, do both of the following apply:  * Is the person a participant of a declared workplace based training program; and. * The workplace based training program occurs after the person providing the training has entered into an agreement to provide the training?",
      "question_summary": "As a provider of a workplace based training program declared under regulation, do both of the following apply: 1) Is the person a participant of a declared workplace based training program, and 2) The workplace based training program occurs after the person providing the training has entered into an agreement to provide the training?",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1089935",
      "children": [
        "1095776",
        "1088904"
      ]
    },
    "1095776": {
      "id": "1095776",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.19-p129/8.435-p130",
      "asset_name": "8.435 (P130)",
      "complete_name": "8.435 (P130) Deemed worker of the person providing the workplace based training program",
      "reference": "8.435 (P130)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Deemed worker of the person providing the workplace based training program",
      "question": "Our Guidance: Deemed worker of the person providing the workplace-based training program",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095772"
    },
    "1095814": {
      "id": "1095814",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.4/5.0-p46",
      "asset_name": "5.0 (P46)",
      "complete_name": "5.0 (P46) Worker status of a natural person assessment - step 1",
      "reference": "5.0 (P46)",
      "option_displayed_on_parent": "Commence worker status of a natural person assessment",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Worker status of an individual person assessment - step 1",
      "question": "Is the person covered by an apprenticeship or trainee contract?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1090103",
      "children": [
        "1085887",
        "1085963"
      ]
    },
    "1095859": {
      "id": "1095859",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.2-p18/4.2.3/8.602-p24",
      "asset_name": "8.602 (P24)",
      "complete_name": "8.602 (P24) Contractor results page",
      "reference": "8.602 (P24)",
      "option_displayed_on_parent": "Yes, the trustee is an incorporated trust.",
      "option_displayed_on_parent_tooltip": "&lt;h2&gt;Incorporated trustees&lt;/h2&gt;&lt;p&gt;Incorporated trustees will not be workers or deemed workers for the purpose of insurance premiums.&lt;/p&gt;&lt;p&gt;However, a working beneficiary of a trustee is classified as a worker of that trustee. If you need to find the worker status of a beneficiary of a trust, you can use this tool for that purpose.&lt;/p&gt;&lt;p&gt;If you want to use this tool for that purpose, please start the tool again and answer the questions accordingly.&lt;/p&gt;&lt;p&gt;Employers are required by law to obtain and maintain workers compensation insurance in respect of all workers (and deemed workers) - including working beneficiaries.&lt;/p&gt;",
      "options_type_display": "Button",
      "page_name": "Contractor results page",
      "question": "Our Guidance: Contractor (Not a worker or a deemed worker)",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1087649"
    },
    "1099205": {
      "id": "1099205",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.4/7.0-p53/7.1-p55/7.1.1.1-p58",
      "asset_name": "7.1.1.1 (P58)",
      "complete_name": "7.1.1.1 (P58) Other contractors assessment - value of the work",
      "reference": "7.1.1.1 (P58)",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Other contractors assessment - value of the work",
      "question": "Value of the work: Is the contract valued at over $10?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1088348",
      "children": [
        "1088364",
        "1088376"
      ]
    },
    "1101437": {
      "id": "1101437",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/5.0-p46temp",
      "asset_name": "5.0 (P46)TEMP",
      "complete_name": "5.0 (P46) Worker status of a natural person assessment -step 1",
      "reference": "5.0 (P46)",
      "option_displayed_on_parent": "No, none of the above.",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Worker status of a natural person assessment - step 1",
      "question": "Is the person covered by an apprenticeship or trainee contract?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1089935",
      "children": [
        "1085887",
        "1085963"
      ]
    },
    "1104967": {
      "id": "1104967",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.14-p112/9.14.1",
      "asset_name": "9.14.1",
      "complete_name": "9.14.1 (P112) Selected and engaged at that place of pickup?",
      "reference": "9.14.1 (P112)",
      "option_displayed_on_parent": "Yes",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Selected and engaged at that place of pickup?",
      "question": "Was the person selected and engaged in this instance, at that place of pickup?",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1095672",
      "children": [
        "1095676",
        "1104973"
      ]
    },
    "1104973": {
      "id": "1104973",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.1-p10/4.1.3-p16/9.14-p112/9.14.1/8.395.1",
      "asset_name": "8.395.1",
      "complete_name": "8.395.1 (P116) Deemed worker of the employer who previously selected and engaged the person",
      "reference": "8.395.1 (P116)",
      "option_displayed_on_parent": "No",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Deemed worker of the employer who previously selected and engaged the person",
      "question": "Deemed worker of the previous employer (if not selected) when travelling back home from the place of pick up.",
      "question_summary": "",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1104967"
    },
    "1128592": {
      "id": "1128592",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.3",
      "asset_name": "4.3",
      "complete_name": "4.3 Individual partner performing work for their partnership assessment",
      "reference": "4.3",
      "option_displayed_on_parent": "An individual who is a partner, performing work for their partnership.",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Individual partner performing work for their partnership assessment",
      "question": "",
      "question_summary": "Confirmed that the partner is performing work for the partnership.",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1085604",
      "children": [
        "1128596"
      ]
    },
    "1128596": {
      "id": "1128596",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.3/8.769",
      "asset_name": "8.769",
      "complete_name": "8.769 Partnership results page",
      "reference": "8.769",
      "option_displayed_on_parent": "An individual who is a partner, performing work for their partnership.",
      "option_displayed_on_parent_tooltip": "",
      "options_type_display": "Button",
      "page_name": "Partner of a Partnership results page",
      "question": "",
      "question_summary": "A partner, performing work for their partnership.",
      "explanatory_content": "",
      "page_type": "Summary",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1128592"
    },
    "1128600": {
      "id": "1128600",
      "url": "https://www.sira.nsw.gov.au/service-worker-tool-decision-tree/Decision-Tree-structure/0.0/1.0-p1-and-p3/2.0-p4/3.0-p6/4.0-p8/4.4",
      "asset_name": "4.4",
      "complete_name": "4.4 Individual partner performing work for a principal contractor assessment",
      "reference": "4.4",
      "option_displayed_on_parent": "An individual who is a partner, performing work for a principal contractor.",
      "option_displayed_on_parent_tooltip": "&lt;h2&gt;An individual who is a partner, performing work for a principal contractor.&lt;/h2&gt;&lt;p&gt;For example, where a partnership owns a truck, and a construction company (the principal contractor) pays the partnership for a partner to drive the truck.&lt;/p&gt;",
      "options_type_display": "Button",
      "page_name": "Partner performing work for a principal contractor assessment",
      "question": "",
      "question_summary": "Confirmed reponse was:",
      "explanatory_content": "",
      "page_type": "Question",
      "prev_text": "Previous",
      "next_text": "Continue",
      "parent": "1085604",
      "children": [
        "1088340"
      ]
    }
  }
} 


export default testData;